//imports front
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  Fragment,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import { AlertContext } from "../../context/AlertContext";
import * as EmailValidator from "email-validator";
import "primeflex/primeflex.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Dialog } from "primereact/dialog";
import Box from "@mui/material/Box";
import ButtonMui from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Close";
import { ServiciosContext } from "../../context/ServiciosContext";
import { Tag } from "primereact/tag";
import { Card } from "primereact/card";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import CheckboxMui from "@mui/material/Checkbox";
import { Toast } from "primereact/toast";
import Spinner from "./Spinner";
import { Navigate, useNavigate } from "react-router-dom";
import Menu from "./Menu";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import TextField from "@mui/material/TextField";
import { SelectButton } from "primereact/selectbutton";
import { TabView, TabPanel } from "primereact/tabview";
import { Document, Page, pdfjs } from "react-pdf";
import pdfCaidas from "./caidas.pdf";
import pdfUlceras from "./ulcerasporpresion.pdf";
import pdfEnfermeria from "./enfermeria.pdf";
import { jsPDF } from "jspdf";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import html2canvas from "html2canvas";
import { maxWidth } from "@mui/system";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// Opciones de la ficha de caídas; el valor se guarda como texto ("Otro: ..." cuando es otro)
const opcionesLugar = ["Institución", "Calle", "Casa", "Otro"];
const opcionesLugarInstitucion = ["Habitación", "Comedor", "Baño", "Pasillo", "Otro"];

// Las fichas viejas tienen texto libre: si no coincide con una opción se toma como "Otro"
const separarOpcion = (valor, lista) => {
  if (!valor) return { opcion: null, otro: "" };
  const texto = String(valor).trim();
  const coincide = lista.find((o) => o.toLowerCase() === texto.toLowerCase());
  if (coincide && coincide !== "Otro") return { opcion: coincide, otro: "" };
  return { opcion: "Otro", otro: texto.replace(/^otro:?\s*/i, "") };
};

const unirOpcion = (opcion, otro) =>
  opcion === "Otro" ? `Otro: ${otro || ""}` : opcion;

// Los radios SI/NO guardan "true"/"false" como string hasta que se recarga desde la base
const esSi = (valor) => valor === true || valor === "true";
const marca = (valor) => (esSi(valor) ? "[X]" : "[ ]");

// Checklist del protocolo de fuga (CHECKLIST_FUGA_PARED), usado en el formulario y en el PDF
const seccionesFuga = [
  {
    titulo: "MINUTO 1: DETECTAR Y AVISAR",
    items: [
      ["verificarAreas", "Verificar EN TODAS LAS ÁREAS (baños, pasillos, patio)"],
      ["fugaConfirmada", "Si NO está en 5 minutos → ¡FUGA CONFIRMADA!"],
      ["gritarAlerta", 'Gritar: "¡FUGA DE [NOMBRE]!"'],
    ],
  },
  {
    titulo: "MINUTOS 2-3: ALERTAR A DIRECCIÓN",
    items: [
      ["llamarDireccion", "Llamar Coordinador/Director INMEDIATAMENTE"],
      ["informarDatos", 'Decir: "FUGA CONFIRMADA: [Nombre], [edad], [descripción]"'],
      ["darHoraExacta", "Dar HORA EXACTA de la fuga"],
    ],
  },
  {
    titulo: "MINUTO 4-5: BÚSQUEDA RÁPIDA ADENTRO",
    items: [
      ["buscarInterior", "Revisar: closets, sótano, áreas ocultas"],
      ["pasarBusquedaExterna", "Si NO está → BÚSQUEDA EXTERNA"],
    ],
  },
  {
    titulo: "MINUTO 5: LLAMAR POLICÍA",
    items: [
      ["llamarPolicia", "TELÉFONO: 101 (Policía) O 911 (Emergencia)"],
      [
        "darInformacionPolicia",
        'DAR INFORMACIÓN: nombre y edad, descripción física, ropa, "tiene demencia/confusión", dirección residencia',
      ],
    ],
  },
  {
    titulo: "MINUTO 5: AVISAR A FAMILIA",
    items: [
      ["llamarFamilia", "LLAMADA INMEDIATA a contacto de emergencia"],
      ["explicarFamilia", "Explicar: qué pasó, cuándo, qué se está haciendo"],
      ["pedirLugaresFamilia", "Pedir información: lugares donde solía ir"],
    ],
  },
  {
    titulo: "MINUTOS 5+: BÚSQUEDA EXTERNA",
    items: [
      ["equipoCuadra", "EQUIPO 1: Cuadra alrededor (radio 4-5 cuadras)"],
      ["equipoHospital", "EQUIPO 2: Hospital, policía, comercios cercanos"],
      ["equipoParadas", "EQUIPO 3: Paradas colectivo, estaciones"],
    ],
  },
  {
    titulo: "MINUTO 10+: SI NO SE ENCUENTRA",
    items: [
      ["publicarRedes", "Publicar EN REDES SOCIALES"],
      ["contactarMedios", "Contactar MEDIOS (TV, radio, diarios)"],
      ["seguirBusquedaPolicia", "Seguir búsqueda coordinada con policía"],
    ],
  },
];

export default function Eventos() {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const isPortrait = window.matchMedia("(orientation: portrait)").matches;

  const [dialogEvoluciones, setDialogEvoluciones] = useState(false);
  const [dialogFichaCaida, setDialogFichaCaida] = useState(false);
  const [dialogControlCaida, setDialogControlCaida] = useState(false);
  const [dialogDiabetes, setDialogDiabetes] = useState(false);
  const [dialogAnticoagulados, setDialogAnticoagulados] = useState(false);
  const [dialogUlcera, setDialogUlcera] = useState(false);
  const [dialogEnfermeria, setDialogEnfermeria] = useState(false);
  const [band, setBand] = useState(true);
  const [card, setCard] = useState(null);
  const toast = useRef(null);
  let navigate = useNavigate();
  const [dialogPacientes, setDialogPacientes] = useState(false);
  const [dialogEvolucion, setDialogEvolucion] = useState(false);
  const [exit, setExit] = useState(false);
  const [tipo, setTipo] = useState("evolucion");
  const veces = ["Si", "No"];
  const [primera, setPrimera] = useState("Si");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);
  const [caida, guardarCaida] = useState(null);
  const [diabete, guardarDiabete] = useState(null);
  const [ulcera, guardarUlcera] = useState(null);
  const [enfermeria, guardarEnfermeria] = useState(null);
  const [anticoagulado, guardarAnticoagulado] = useState(null);
  const [sujecion, guardarSujecion] = useState(null);
  const [dialogSujecion, setDialogSujecion] = useState(false);
  const [confundido, guardarConfundido] = useState(null);
  const [dialogConfundido, setDialogConfundido] = useState(false);
  const [fuga, guardarFuga] = useState(null);
  const [dialogFuga, setDialogFuga] = useState(false);

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    statusAcceso,
    evolucion,
    caidas,
    historiasClinicas,
    paciente,
    pacientes,
    historiaClinica,
    geriatricoElegido,
    visible,
    fragilidad,
    antecedente,
    actual,
    examenI,
    examenII,
    examenIII,
    evoluciones,
    diabetes,
    anticoagulados,
    sujeciones,
    confundidos,
    fugas,
    ulceras,
    enfermerias,
    selectedRowPaciente,
    validarHistoriaClinica,
    obtenerHistoriasClinicas,
    obtenerAcceso,
    obtenerAcceso2,
    obtenerAcceso3,
    obtenerAcceso4,
    obtenerAcceso5,
    agregarHistoriaClinica,
    actualizarHistoriaClinica,
    setGeriatricoElegido,
    obtenerPaciente,
    obtenerPacientes,
    setSelectedRowPaciente,
    obtenerEvoluciones,
    guardarEvolucion,
    guardarCaidas,
    agregarEvolucion,
    obtenerFichasCaidas,
    agregarFichasCaidas,
    actualizarFichasCaidas,
    obtenerControlCaidas,
    agregarControlCaidas,
    actualizarControlCaidas,
    obtenerDiabetes,
    guardarDiabetes,
    agregarDiabetes,
    actualizarDiabetes,
    obtenerUlceras,
    guardarUlceras,
    agregarUlceras,
    actualizarUlceras,
    guardarEnfermerias,
    obtenerEnfermerias,
    agregarEnfermerias,
    actualizarEnfermerias,
    obtenerAnticoagulados,
    guardarAnticoagulados,
    agregarAnticoagulados,
    actualizarAnticoagulados,
    obtenerOrdenesSujecion,
    agregarOrdenSujecion,
    actualizarOrdenSujecion,
    guardarSujeciones,
    obtenerResidentesConfundidos,
    agregarResidenteConfundido,
    actualizarResidenteConfundido,
    guardarConfundidos,
    obtenerFugas,
    agregarFuga,
    actualizarFuga,
  } = serviciosContext;

  useEffect(() => {
    usuarioAutenticado();
  }, []);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "Evoluciones",
      });
    }
  }, [state]);

  useEffect(() => {
    setGeriatricoElegido({
      id: Number(localStorage.getItem("geriatricoElegidoId")),
      nombre: localStorage.getItem("geriatricoElegidoNombre"),
    });
    obtenerPacientes({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
  }, []);

  const exitClick = (e) => {
    navigate("/");
  };

  // Hoja 2 de caídas: con datos imprime la ficha cargada, sin datos el protocolo + la ficha en blanco
  const armarPdfCaidas = async (c) => {
    const MM = 2.83464567;
    const existingBytes = await fetch(pdfCaidas).then((r) => r.arrayBuffer());
    const srcDoc = await PDFDocument.load(existingBytes);
    const pdfDoc = await PDFDocument.create();
    const [protocoloPage] = await pdfDoc.copyPages(srcDoc, [0]);
    if (!c) {
      pdfDoc.addPage(protocoloPage);
    }

    const fontNormal = await pdfDoc.embedFont(StandardFonts.TimesRoman);
    const fontBold = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);

    const { width: PAGE_W, height: PAGE_H } = protocoloPage.getSize();
    const page = pdfDoc.addPage([PAGE_W, PAGE_H]);
    const datos = c || {};

    const toY = (yMm) => PAGE_H - yMm * MM;
    const toX = (xMm) => xMm * MM;

    // Las fuentes estándar de pdf-lib solo codifican WinAnsi
    const limpiar = (valor) =>
      (valor === null || valor === undefined ? "" : String(valor)).replace(
        /[^\x20-\x7E\xA0-\xFF]/g,
        ""
      );

    const text = (str, xMm, yMm, opts = {}) => {
      page.drawText(limpiar(str), {
        x: toX(xMm),
        y: toY(yMm),
        size: opts.size || 11,
        font: opts.bold ? fontBold : fontNormal,
        color: rgb(0, 0, 0),
      });
    };

    const linea = (x1Mm, yMm, x2Mm) => {
      page.drawLine({
        start: { x: toX(x1Mm), y: toY(yMm) },
        end: { x: toX(x2Mm), y: toY(yMm) },
        thickness: 0.7,
        color: rgb(0, 0, 0),
      });
    };

    // Recorta el texto para que entre en el ancho disponible
    const ajustar = (str, anchoMm, size = 10) => {
      let salida = limpiar(str);
      while (
        salida.length > 0 &&
        fontNormal.widthOfTextAtSize(salida, size) > anchoMm * MM
      ) {
        salida = salida.slice(0, -1);
      }
      return salida;
    };

    const envolver = (str, anchoMm, size = 10) => {
      const lineas = [];
      let actual = "";
      limpiar(str)
        .split(/\s+/)
        .filter(Boolean)
        .forEach((palabra) => {
          const prueba = actual ? actual + " " + palabra : palabra;
          if (fontNormal.widthOfTextAtSize(prueba, size) > anchoMm * MM && actual) {
            lineas.push(actual);
            actual = palabra;
          } else {
            actual = prueba;
          }
        });
      if (actual) lineas.push(actual);
      return lineas;
    };

    // Valor escrito sobre la línea, entre x1 y x2
    const campo = (valor, x1Mm, yMm, x2Mm) => {
      linea(x1Mm, yMm, x2Mm);
      if (valor) text(ajustar(valor, x2Mm - x1Mm - 1), x1Mm + 1, yMm - 1, { size: 10 });
    };

    const opciones = (lista, valor) => {
      const { opcion } = separarOpcion(valor, lista);
      return lista.map((o) => `${opcion === o ? "[X]" : "[ ]"} ${o}`).join("   ");
    };

    let y = 0;
    const bloque = (etiqueta, valor, cantidadLineas) => {
      text(etiqueta, 10, y);
      const partes = envolver(valor, 188);
      for (let i = 0; i < cantidadLineas; i++) {
        y += 6;
        if (partes[i]) text(partes[i], 11, y - 1, { size: 10 });
        linea(10, y, 200);
      }
      y += 8;
    };

    text("FICHA DE EVALUACIÓN DE CAIDAS", 55, 15, { size: 14, bold: true });

    y = 28;
    text("Residencia:", 10, y);
    campo((geriatricoElegido && geriatricoElegido.nombre) || "", 32, y + 1, 200);

    y += 10;
    text("Apellido y Nombre:", 10, y);
    campo(selectedRowPaciente ? selectedRowPaciente.nombre : "", 52, y + 1, 200);

    y += 10;
    if (datos.fecha) {
      text("Día:", 10, y);
      campo(formatDate(datos.fecha), 19, y, 60);
    } else {
      text("Dia __ /__ /__", 10, y);
    }
    if (datos.hora) {
      text("Hora:", 70, y);
      campo(String(datos.hora).slice(0, 5), 81, y, 110);
    } else {
      text("Hora __:__", 70, y);
    }

    y += 10;
    text("Testigo:", 10, y);
    campo(datos.testigo, 30, y, 200);

    y += 10;
    text("Lugar del acontecimiento:  " + opciones(opcionesLugar, datos.lugar), 10, y);
    y += 7;
    text("Otro:", 10, y);
    campo(separarOpcion(datos.lugar, opcionesLugar).otro, 22, y, 200);

    y += 10;
    text(
      "Lugar de la institución:  " +
        opciones(opcionesLugarInstitucion, datos.lugar2),
      10,
      y
    );
    y += 7;
    text("Otro:", 10, y);
    campo(separarOpcion(datos.lugar2, opcionesLugarInstitucion).otro, 22, y, 200);

    y += 10;
    bloque("Circunstancia:", datos.circunstancia, 2);
    bloque("Diagnóstico del paciente:", datos.diagnostico, 2);
    bloque("Intercurrencias médicas que puedan influir:", datos.intercurrencias, 2);
    bloque("Medicamentos que ingiere:", datos.medicamentos, 2);

    text("Condiciones del lugar:", 10, y, { bold: true });

    y += 9;
    text("Piso:", 10, y);
    campo(datos.piso, 20, y, 65);
    text("Iluminación:", 75, y);
    campo(datos.iluminacion, 98, y, 130);
    text("Obstáculos:", 140, y);
    campo(datos.obstaculos, 163, y, 200);

    y += 9;
    text("Barandas:", 10, y);
    campo(datos.barandas, 30, y, 65);
    text("Cama:", 75, y);
    campo(datos.cama, 88, y, 130);
    text("Escalera:", 140, y);
    campo(datos.escaleras, 160, y, 200);

    y += 9;
    text("Calzado:", 10, y);
    campo(datos.calzado, 28, y, 65);
    text("Silla:", 75, y);
    campo(datos.silla, 86, y, 130);
    text("Acompañante:", 140, y);
    campo(datos.acompanante, 168, y, 200);

    y += 9;
    const esPrimera = c ? primera === "Si" : null;
    text(
      `Primera vez:  ${esPrimera === true ? "[X]" : "[ ]"} SI   ${
        esPrimera === false ? "[X]" : "[ ]"
      } NO`,
      10,
      y
    );
    text("Ultima vez: ... Fecha: __ /__ /__", 70, y);
    linea(165, y, 200);

    y += 10;
    bloque("Escala de Tinetti:", datos.tinetti, 2);
    bloque("Consecuencias:", datos.consecuencias, 3);

    y += 4;
    text("Firma", 10, y);
    linea(25, y, 90);

    y += 10;
    text("Aclaración:", 10, y);
    linea(35, y, 100);

    const outBytes = await pdfDoc.save();
    const blob = new Blob([outBytes], { type: "application/pdf" });
    window.open(URL.createObjectURL(blob));
  };

  // Resumen / comentario de cada evento; se muestra en el Resumen VGI
  const campoResumen = (valor, onChange) => (
    <Grid item xs={12} md={12}>
      <TextField
        id="resumen"
        label="Resumen / Comentario (se lleva al Resumen VGI)"
        fullWidth
        multiline
        rows={3}
        variant="standard"
        value={valor || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    </Grid>
  );

  const imprimir = async (e) => {
    if (tipo === "evolucion") {
      var line = 25; // Line height to start text at
      var lineHeight = 5;
      var leftMargin = 20;
      var wrapWidth = 180;
      var longString = evolucion;

      const doc = new jsPDF();

      doc.setFontSize(14);
      doc.text("EVOLUCION RESIDENTE " + selectedRowPaciente.nombre, 50, 10);

      doc.setFontSize(12);

      doc.setFontSize(12);
      var splitText = doc.splitTextToSize(longString, wrapWidth);
      for (var i = 0, length = splitText.length; i < length; i++) {
        // loop thru each line and increase
        doc.text(splitText[i], leftMargin, line);
        line = lineHeight + line;
      }

      let lineDate = line + 10;
      doc.text(formatDate(selectedRow.fecha), 10, lineDate);

      window.open(doc.output("bloburl"));
      /*
      doc.save(
        "evolucion_" +
          selectedRowPaciente.nombre +
          "_" +
          new Date().toLocaleDateString() +
          ".pdf"
      );
      */
    }

    if (tipo === "caidas") {
      // Desde el diálogo se imprime la ficha cargada; desde la pestaña Protocolo, protocolo + ficha en blanco
      armarPdfCaidas(dialogFichaCaida ? caida || {} : null);

      if (activeIndex === 2) {
        const doc = new jsPDF();

        doc.setFontSize(14);
        doc.text("FICHA DE CONTROL DE CAIDAS", 50, 10);

        doc.setFontSize(12);

        doc.text(
          "Apellido y Nombre: " + selectedRowPaciente.nombre,
          10,
          20,
          "left",
          "middle"
        );

        doc.text(
          "Fecha: " +
            (caida !== undefined &&
            caida !== null &&
            caida.fecha !== undefined &&
            caida.fecha !== null
              ? formatDate(caida.fecha)
              : ""),
          10,
          25,
          "left",
          "middle"
        );

        doc.text(
          "Lugar del acontecimiento (institución) (calle) casa) (otro): " +
            (caida !== undefined &&
            caida !== null &&
            caida.lugar !== undefined &&
            caida.lugar !== null
              ? caida.lugar
              : ""),
          10,
          35,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "Consecuencias: " +
            (caida !== undefined &&
            caida !== null &&
            caida.consecuencias !== undefined &&
            caida.consecuencias !== null
              ? caida.consecuencias
              : ""),
          10,
          55,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "Tratamiento: " +
            (caida !== undefined &&
            caida !== null &&
            caida.tratamiento !== undefined &&
            caida.tratamiento !== null
              ? caida.tratamiento
              : ""),
          10,
          75,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        window.open(doc.output("bloburl"));
        /*
        doc.save(
          "ControlCaidas_" +
            selectedRowPaciente.nombre +
            "export_" +
            new Date().toLocaleDateString() +
            ".pdf"
        );
        */
      }
    }

    if (tipo === "diabetes") {
      const doc = new jsPDF();

      doc.setFontSize(14);
      doc.text("FICHA DE CONTROL DE DIABETES", 50, 10);

      doc.setFontSize(12);

      doc.text(
        "Apellido y Nombre: " + selectedRowPaciente.nombre,
        10,
        20,
        "left",
        "middle"
      );

      doc.text(
        "Fecha: " +
          (diabete !== undefined &&
          diabete !== null &&
          diabete.fecha !== undefined &&
          diabete.fecha !== null
            ? formatDate(diabete.fecha)
            : ""),
        10,
        25,
        "left",
        "middle"
      );

      doc.text(
        "Tipo: " +
          (diabete !== undefined &&
          diabete !== null &&
          diabete.tipo !== undefined &&
          diabete.tipo !== null
            ? diabete.tipo
            : ""),
        10,
        35,
        {
          maxWidth: 200,
          align: "left",
        }
      );

      doc.text(
        "Medicación: " +
          (diabete !== undefined &&
          diabete !== null &&
          diabete.medicacion !== undefined &&
          diabete.medicacion !== null
            ? diabete.medicacion
            : ""),
        10,
        45,
        {
          maxWidth: 200,
          align: "left",
        }
      );

      doc.text(
        "Valor: " +
          (diabete !== undefined &&
          diabete !== null &&
          diabete.valor !== undefined &&
          diabete.valor !== null
            ? diabete.valor
            : ""),
        10,
        55,
        {
          maxWidth: 200,
          align: "left",
        }
      );

      doc.text(
        "Control: " +
          (diabete !== undefined &&
          diabete !== null &&
          diabete.control !== undefined &&
          diabete.control !== null
            ? diabete.control
            : ""),
        10,
        65,
        {
          maxWidth: 200,
          align: "left",
        }
      );

      window.open(doc.output("bloburl"));
      /*
      doc.save(
        "Diabetes_" +
          selectedRowPaciente.nombre +
          "export_" +
          new Date().toLocaleDateString() +
          ".pdf"
      );
      */
    }

    if (tipo === "ulceras") {
      if (activeIndex === 0) {
        //window.open(pdfCaidas, "PRINT", "height=400,width=600");
        window.open(pdfUlceras, "_blank");
      }

      if (activeIndex === 1) {
        const doc = new jsPDF();

        doc.setFontSize(14);
        doc.text("FICHA DE CONTROL DE ULCERAS POR PRESION", 50, 10);

        doc.setFontSize(12);

        doc.text(
          "Apellido y Nombre: " + selectedRowPaciente.nombre,
          10,
          20,
          "left",
          "middle"
        );

        doc.text(
          "Fecha: " +
            (ulcera !== undefined &&
            ulcera !== null &&
            ulcera.fecha !== undefined &&
            ulcera.fecha !== null
              ? formatDate(ulcera.fecha)
              : ""),
          10,
          25,
          "left",
          "middle"
        );

        doc.text(
          "Valoración: " +
            (ulcera !== undefined &&
            ulcera !== null &&
            ulcera.valoracion !== undefined &&
            ulcera.valoracion !== null
              ? ulcera.valoracion
              : ""),
          10,
          35,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "Localización: " +
            (ulcera !== undefined &&
            ulcera !== null &&
            ulcera.localizacion !== undefined &&
            ulcera.localizacion !== null
              ? ulcera.localizacion
              : ""),
          10,
          45,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "Evolución de la Ulcera: " +
            (ulcera !== undefined &&
            ulcera !== null &&
            ulcera.mejora !== undefined &&
            ulcera.mejora !== null &&
            ulcera.mejora
              ? "Mejora"
              : ulcera.estable !== undefined &&
                ulcera.estable !== null &&
                ulcera.estable
              ? "Estable"
              : ulcera.empeora !== undefined &&
                ulcera.empeora !== null &&
                ulcera.empeora
              ? "Esmpeora"
              : ulcera.curada !== undefined &&
                ulcera.curada !== null &&
                ulcera.curada
              ? "Curada"
              : null),

          10,
          55
        );

        doc.text(
          "Cambio de TTO: " +
            (ulcera !== undefined &&
            ulcera !== null &&
            ulcera.tto !== undefined &&
            ulcera.tto !== null
              ? ulcera.tto
              : ""),
          10,
          65,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text("Firma: ____________________________________ ", 40, 85);

        doc.text("Aclaración: ____________________________________ ", 40, 105);

        window.open(doc.output("bloburl"));
        /*
        doc.save(
          "ControlUlceras" +
            selectedRowPaciente.nombre +
            "export_" +
            new Date().toLocaleDateString() +
            ".pdf"
        );
        */
      }
    }

    if (tipo === "enfermeria") {
      if (activeIndex === 0) {
        //window.open(pdfCaidas, "PRINT", "height=400,width=600");
        window.open(pdfEnfermeria, "_blank");
      }

      if (activeIndex === 1) {
        const doc = new jsPDF();

        doc.setFontSize(14);
        doc.text("FICHA DE CONTROL DE ENFERMERIA", 50, 10);

        doc.setFontSize(12);

        doc.text(
          "Apellido y Nombre: " + selectedRowPaciente.nombre,
          10,
          20,
          "left",
          "middle"
        );

        doc.text(
          "Fecha: " +
            (enfermeria !== undefined &&
            enfermeria !== null &&
            enfermeria.fecha !== undefined &&
            enfermeria.fecha !== null
              ? formatDate(enfermeria.fecha)
              : ""),
          10,
          25,
          "left",
          "middle"
        );

        doc.text(
          "Medicación: " +
            (enfermeria !== undefined &&
            enfermeria !== null &&
            enfermeria.medicacion !== undefined &&
            enfermeria.medicacion !== null
              ? enfermeria.medicacion
              : ""),
          10,
          35,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "Temperatura: " +
            (enfermeria !== undefined &&
            enfermeria !== null &&
            enfermeria.temperatura !== undefined &&
            enfermeria.temperatura !== null
              ? enfermeria.temperatura
              : ""),
          10,
          45,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "T.A.: " +
            (enfermeria !== undefined &&
            enfermeria !== null &&
            enfermeria.tension !== undefined &&
            enfermeria.tension !== null
              ? enfermeria.tension
              : ""),
          10,
          50,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "F.C.: " +
            (enfermeria !== undefined &&
            enfermeria !== null &&
            enfermeria.frecuencia !== undefined &&
            enfermeria.frecuencia !== null
              ? enfermeria.frecuencia
              : ""),
          10,
          55,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        doc.text(
          "Observaciones: " +
            (enfermeria !== undefined &&
            enfermeria !== null &&
            enfermeria.observaciones !== undefined &&
            enfermeria.observaciones !== null
              ? enfermeria.observaciones
              : ""),
          10,
          60,
          {
            maxWidth: 200,
            align: "left",
          }
        );

        window.open(doc.output("bloburl"));
        /*
        doc.save(
          "ControlEnfermeria" +
            selectedRowPaciente.nombre +
            "export_" +
            new Date().toLocaleDateString() +
            ".pdf"
        );
        */
      }
    }

    if (tipo === "sujecion") {
      const doc = new jsPDF();
      const s = sujecion || {};

      doc.setFontSize(14);
      doc.setFont("Times", "bolditalic");
      doc.text("ORDEN DE SUJECION MECANICA", 40, 12);
      doc.setFont("Times", "normal");
      doc.setFontSize(10);
      doc.text((geriatricoElegido && geriatricoElegido.nombre) || "", 14, 20);

      let row = 30;
      doc.setFontSize(11);
      doc.text("DATOS DEL RESIDENTE", 10, row);
      row += 7;
      doc.setFontSize(9);
      doc.text(
        `Nombre Completo: ${s.nombreCompleto || (selectedRowPaciente ? selectedRowPaciente.nombre : "")}`,
        10,
        row,
      );
      row += 6;
      doc.text(`DNI / Edad: ${s.dniEdad || ""}`, 10, row);
      row += 6;
      doc.text(`Habitación / Piso: ${s.habitacionPiso || ""}`, 10, row);
      row += 6;
      doc.text(`Diagnóstico Principal: ${s.diagnosticoPrincipal || ""}`, 10, row);
      row += 6;
      doc.text(`Medicación Actual: ${s.medicacionActual || ""}`, 10, row);

      row += 10;
      doc.setFontSize(11);
      doc.text("MOTIVO DE LA SUJECION MECANICA", 10, row);
      row += 7;
      doc.setFontSize(9);
      doc.text(
        `${marca(s.motivoLevantarse)} Intento REPETIDO de levantarse de cama (riesgo de caída/fractura)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.motivoCateter)} Arrancarse catéter / sonda / venoclisis (riesgo de sangrado)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.motivoAgitacion)} Agitación SEVERA con autolesiones (golpearse)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.motivoAgresion)} Agresión directa a personal de residencia`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.motivoDeambulacion)} Deambulación peligrosa / inestabilidad severa`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.motivoOtro)} Otro (especificar): ${s.motivoOtroTexto || ""}`,
        10,
        row,
      );

      row += 9;
      doc.text("Descripción detallada del riesgo y conducta:", 10, row);
      row += 6;
      const lineasRiesgo = doc.splitTextToSize(s.descripcionRiesgo || "", 190);
      doc.text(lineasRiesgo, 10, row);
      row += Math.max(lineasRiesgo.length, 2) * 5 + 4;

      doc.setFontSize(11);
      doc.text("ALTERNATIVAS INTENTADAS ANTES DE LA SUJECION", 10, row);
      row += 7;
      doc.setFontSize(9);
      doc.text(
        `${marca(s.altNoFarmacologica)} Intervención no-farmacológica (ambiente tranquilo, validación emocional)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.altRedireccionamiento)} Redireccionamiento de atención (actividades, música, paseo)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.altCausaMedica)} Evaluación de causa médica (fiebre, dolor, infección, medicación)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.altMedicacion)} Medicación considerada (ansiolíticos si corresponde)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.altPersonal)} Aumento de personal (vigilancia intensiva)`,
        10,
        row,
      );

      row += 9;
      doc.setFontSize(11);
      doc.text("TIPO DE SUJECION INDICADA", 10, row);
      row += 7;
      doc.setFontSize(9);
      doc.text(
        `${marca(s.tipoSujecion === "Cinturón de seguridad")} CINTURON DE SEGURIDAD (en cama o silla)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.tipoSujecion === "Pulseras suave")} PULSERAS SUAVE (muñecas y/o tobillos)`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.tipoSujecion === "Chaleco de contención")} CHALECO DE CONTENCION`,
        10,
        row,
      );
      row += 6;
      doc.text(
        `${marca(s.tipoSujecion === "Manta con sistema de fijación")} MANTA CON SISTEMA DE FIJACION`,
        10,
        row,
      );

      row += 10;
      doc.setFontSize(11);
      doc.text("DURACION Y HORARIO", 10, row);
      row += 7;
      doc.setFontSize(9);
      doc.text("Fecha de Inicio: ______________________", 10, row);
      row += 6;
      doc.text("Hora de Inicio: ______________________", 10, row);
      row += 6;
      doc.text("Duración Máxima: [ ] 24 horas (máximo permisible)", 10, row);
      row += 6;
      doc.text("Reevaluación Prevista: En 24 horas (OBLIGATORIO)", 10, row);

      doc.addPage();

      row = 15;
      doc.setFontSize(12);
      doc.setFont("Times", "bold");
      doc.text("INSTRUCCIONES ESPECIFICAS PARA EL PERSONAL", 10, row);
      doc.setFont("Times", "normal");
      row += 8;

      doc.setFontSize(10);
      doc.text("CUIDADOS DURANTE LA SUJECION:", 10, row);
      row += 6;
      doc.setFontSize(9);
      [
        "[ ] Permitir movimiento (no inmovilizar completamente)",
        "[ ] NO muy apretado (cabe un dedo)",
        "[ ] Cambios posturales cada 2 horas MINIMO",
        "[ ] Verificar circulación (no azul/pálido/inflamado)",
        "[ ] Permitir higiene (acompañar al baño)",
        "[ ] Alimentación y bebida NORMAL",
        "[ ] Validación emocional continuada",
      ].forEach((texto) => {
        doc.text(texto, 10, row);
        row += 5.5;
      });

      row += 4;
      doc.setFontSize(10);
      doc.text("MONITOREO OBLIGATORIO:", 10, row);
      row += 6;
      doc.setFontSize(9);
      const lineasMonitoreo = doc.splitTextToSize(
        "[ ] CADA 2 HORAS: Comodidad, respiración, circulación y ademas agregar y realizar cambio postural.",
        190,
      );
      doc.text(lineasMonitoreo, 10, row);
      row += lineasMonitoreo.length * 5.5;
      doc.text("[ ] Registro de cada monitoreo en historia clínica", 10, row);
      row += 5.5;

      row += 4;
      doc.setFontSize(10);
      doc.text("SOLTAR INMEDIATAMENTE SI:", 10, row);
      row += 6;
      doc.setFontSize(9);
      [
        "X Inflamación, enrojecimiento severo, úlceras",
        "X Cianosis (dedos/pies azules)",
        "X Entumecimiento u hormigueo",
        "X Dificultad respiratoria",
        "X Sangrado o herida",
      ].forEach((texto) => {
        doc.text(texto, 10, row);
        row += 5.5;
      });

      row += 5;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("CONSENTIMIENTO INFORMADO DE LA FAMILIA", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      [
        "[ ] La razón específica de la sujeción",
        "[ ] El tipo de sujeción a utilizarse",
        "[ ] La duración máxima (24 horas)",
        "[ ] Que será reevaluada cada 24 horas",
        "[ ] Que será monitorizada cada 2 horas",
        "[ ] Que NO es castigo ni maltrato",
      ].forEach((texto) => {
        doc.text(texto, 10, row);
        row += 5.5;
      });
      row += 3;
      doc.text(
        "Nombre familiar que consintió: ________________________   Relación: ______________",
        10,
        row,
      );

      row += 9;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("FIRMA Y RESPONSABILIDAD DEL MEDICO", 10, row);
      doc.setFont("Times", "normal");
      row += 6;
      doc.setFontSize(9);
      doc.text("Confirmo que:", 10, row);
      row += 5.5;
      [
        "[ ] Hay RIESGO GRAVE justificado para la sujeción",
        "[ ] Se intentaron ALTERNATIVAS NO-FARMACOLOGICAS (mínimo 30 minutos)",
        "[ ] He evaluado CAUSA MEDICA",
        "[ ] He informado a la FAMILIA",
        "[ ] Obtuve CONSENTIMIENTO INFORMADO",
        "[ ] Ordeno MONITOREO cada 2 horas",
        "[ ] Ordeno REEVALUACION a las 24 horas",
      ].forEach((texto) => {
        doc.text(texto, 10, row);
        row += 5.5;
      });

      row += 4;
      doc.setFontSize(10);
      doc.text("MEDICO TRATANTE:", 10, row);
      row += 7;
      doc.setFontSize(9);
      doc.text("Sello y Firma: ________________________________________________", 10, row);

      row += 10;
      doc.setFontSize(10);
      doc.text("REEVALUACION A LAS 24 HORAS", 10, row);
      row += 6;
      doc.setFontSize(9);
      doc.text(
        "Hora de Reevaluación: ________________   Fecha: ________________",
        10,
        row,
      );

      doc.setFontSize(8);
      doc.setFont("Times", "bolditalic");
      doc.text(
        "ESTA ORDEN DEBE PERMANECER EN LA HISTORIA CLINICA DEL RESIDENTE",
        105,
        280,
        { align: "center" },
      );
      doc.setFont("Times", "normal");

      window.open(doc.output("bloburl"));
    }

    if (tipo === "confundido") {
      const doc = new jsPDF();
      const c = confundido || {};

      const signos = [
        ["signoCambioBrusco", "Cambio BRUSCO (de golpe, no gradual)"],
        ["signoConfusionDesorientacion", "Confusión / Desorientación"],
        ["signoFluctuacion", "Fluctuación (mejor mañana, peor noche)"],
        ["signoDificultadConcentracion", "Dificultad concentración"],
        ["signoCambiosEmocionales", "Cambios emocionales rápidos"],
        ["signoAlucinaciones", "Alucinaciones / Ve cosas"],
        ["signoSuenoInvertido", "Sueño invertido (duerme día, despierto noche)"],
      ];

      const causas = [
        ["causaFiebre", "¿Tiene fiebre? (tocar frente)"],
        ["causaITU", "¿Hay síntomas de ITU? (disuria, orina turbia)"],
        ["causaTosDificultadRespirar", "¿Tiene tos, dificultad respirar? (neumonía)"],
        ["causaMedicacionReciente", "¿Medicación reciente? (nueva droga)"],
        ["causaCambioAmbiental", "¿Cambio ambiental? (ingreso, cambio cuarto)"],
        ["causaRetencion", "¿Retención urinaria o fecal?"],
        ["causaDolor", "¿Dolor? (expresión de dolor)"],
      ];

      doc.setFontSize(16);
      doc.setFont("Times", "bold");
      doc.text("RESIDENTE CONFUNDIDO DE REPENTE", 105, 14, { align: "center" });
      doc.setFontSize(11);
      doc.setFont("Times", "italic");
      doc.text("PROTOCOLO DE DELIRIUM", 105, 21, { align: "center" });
      doc.setFont("Times", "normal");

      doc.setFontSize(9);
      doc.text((geriatricoElegido && geriatricoElegido.nombre) || "", 10, 28);
      doc.text(
        "Residente: " +
          ((selectedRowPaciente && selectedRowPaciente.nombre) || ""),
        10,
        34,
      );

      let row = 44;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("RECONOCER LOS SIGNOS (¿Tiene delirium?)", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      signos.forEach(([campo, etiqueta]) => {
        doc.text(`${marca(c[campo])} ${etiqueta}`, 10, row);
        row += 6;
      });

      row += 4;
      doc.setFontSize(10);
      doc.setFont("Times", "bold");
      const lineasAlerta = doc.splitTextToSize(
        "SI VES ESTO -> LLAMAR MEDICO INMEDIATAMENTE",
        190,
      );
      doc.text(lineasAlerta, 10, row);
      doc.setFont("Times", "normal");
      row += lineasAlerta.length * 6 + 4;

      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("MIENTRAS ESPERAS MEDICO - BUSCAR CAUSA", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      causas.forEach(([campo, etiqueta]) => {
        doc.text(`${marca(c[campo])} ${etiqueta}`, 10, row);
        row += 6;
      });

      row += 5;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("CUIDADOS INMEDIATOS", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      [
        "Ambiente TRANQUILO",
        "LUZ de día, OSCURIDAD de noche",
        "Reducir ruido (apagar TV, música fuerte)",
        'Orientar: "Es lunes, estás en la residencia"',
        "Persona cuidadora CONSISTENTE",
        "Ofrecer agua, comida",
        "NO contener (a menos que orden médica)",
        "Contacto físico tranquilizador",
        "Permitir visitas de familia",
      ].forEach((texto) => {
        doc.text(`- ${texto}`, 10, row);
        row += 5.5;
      });

      row += 4;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("PROBABLES CAUSAS MEDICAS", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      [
        "1. INFECCION (30-40%) - ITU, neumonía",
        "2. HIPOGLUCEMIA (azúcar baja)",
        "3. DESHIDRATACION",
        "4. MEDICACION (efectos secundarios)",
        "5. DOLOR no controlado",
      ].forEach((texto) => {
        doc.text(texto, 10, row);
        row += 5.5;
      });

      row += 4;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("EL MEDICO ORDENARA:", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      [
        "Orina (detecta ITU)",
        "Hemograma",
        "Glucemia (azúcar)",
        "Electrolitos",
        "RX tórax (si sospecha neumonía)",
      ].forEach((texto) => {
        doc.text(`- ${texto}`, 10, row);
        row += 5.5;
      });

      doc.addPage();

      row = 15;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("TRATAMIENTO (según causa):", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      [
        "ITU -> Antibiótico",
        "Hipoglucemia -> Azúcar 15g",
        "Deshidratación -> Suero IV / agua",
        "Dolor -> Analgesia",
      ].forEach((texto) => {
        doc.text(`- ${texto}`, 10, row);
        row += 5.5;
      });

      row += 5;
      doc.setFontSize(10);
      doc.setFont("Times", "bold");
      doc.text("RESULTADO: Mejora en 3-7 días", 10, row);
      doc.setFont("Times", "normal");

      row += 10;
      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("MONITOREO DIARIO", 10, row);
      doc.setFont("Times", "normal");
      row += 7;
      doc.setFontSize(9);
      [
        "Evaluación mental cada turno",
        "¿Mejoró la confusión?",
        "¿Mejor orientación?",
        "¿Duerme mejor?",
        "Signos vitales",
        "Ingesta de líquidos",
      ].forEach((texto) => {
        doc.text(`[ ] ${texto}`, 10, row);
        row += 5.5;
      });

      row += 14;
      doc.setFontSize(13);
      doc.setFont("Times", "bold");
      doc.text("PUNTOS CLAVE", 105, row, { align: "center" });
      doc.setFont("Times", "normal");

      row += 12;
      doc.setFontSize(10);
      [
        "Delirium es REVERSIBLE",
        "NO es demencia (es AGUDO, no lento)",
        "Tiene CAUSA MEDICA (80% casos)",
        "Buscar y TRATAR causa = MEJORA",
        "Ambiente tranquilo + Orientación = Clave",
        "Con diagnóstico y tratamiento rápido, RECUPERACION COMPLETA",
      ].forEach((texto) => {
        doc.setFont("Times", "bold");
        doc.text(texto, 105, row, { align: "center" });
        row += 9;
      });

      window.open(doc.output("bloburl"));
    }

    if (tipo === "fuga") {
      const doc = new jsPDF();
      const f = fuga || {};

      doc.setFontSize(16);
      doc.setFont("Times", "bold");
      doc.text("¡FUGA! PROTOCOLO DE ACCION", 105, 14, { align: "center" });
      doc.setFontSize(11);
      doc.setFont("Times", "italic");
      doc.text("PRIMEROS 10 MINUTOS SON CRITICOS", 105, 21, { align: "center" });
      doc.setFont("Times", "normal");

      doc.setFontSize(9);
      doc.text((geriatricoElegido && geriatricoElegido.nombre) || "", 10, 28);
      doc.text(
        "Residente: " +
          ((selectedRowPaciente && selectedRowPaciente.nombre) || ""),
        10,
        34,
      );
      doc.text(
        "Fecha: " +
          (selectedRow && selectedRow.fecha ? formatDate(selectedRow.fecha) : "") +
          "     Hora de la fuga: " +
          (f.horaFuga || ""),
        110,
        34,
      );

      let row = 41;
      const lineasDescripcion = doc.splitTextToSize(
        "Descripción física: " + (f.descripcionFisica || ""),
        190,
      );
      doc.text(lineasDescripcion, 10, row);
      row += lineasDescripcion.length * 5;
      const lineasRopa = doc.splitTextToSize(
        "Ropa que llevaba: " + (f.ropa || ""),
        190,
      );
      doc.text(lineasRopa, 10, row);
      row += lineasRopa.length * 5 + 4;

      seccionesFuga.forEach(({ titulo, items }) => {
        doc.setFontSize(11);
        doc.setFont("Times", "bold");
        doc.text(titulo, 10, row);
        doc.setFont("Times", "normal");
        row += 6;
        doc.setFontSize(9);
        items.forEach(([campo, etiqueta]) => {
          const lineas = doc.splitTextToSize(
            `${marca(f[campo])} ${etiqueta.replace("→", "->")}`,
            190,
          );
          doc.text(lineas, 10, row);
          row += lineas.length * 5;
        });
        row += 3;
      });

      doc.setFontSize(11);
      doc.setFont("Times", "bold");
      doc.text("RESULTADO", 10, row);
      doc.setFont("Times", "normal");
      row += 6;
      doc.setFontSize(9);
      doc.text(
        `Encontrado: ${esSi(f.encontrado) ? "SI" : "NO"}     Hora: ${
          f.horaEncontrado || ""
        }     Lugar: ${f.lugarEncontrado || ""}`,
        10,
        row,
      );
      row += 6;
      const lineasObservaciones = doc.splitTextToSize(
        "Observaciones: " + (f.observaciones || ""),
        190,
      );
      doc.text(lineasObservaciones, 10, row);
      row += lineasObservaciones.length * 5 + 6;

      doc.setFontSize(10);
      doc.setFont("Times", "bold");
      doc.text("NUMEROS DE EMERGENCIA:  POLICIA: 101   -   EMERGENCIA: 911", 105, row, {
        align: "center",
      });
      row += 6;
      doc.text("¡NO DEMORES! ¡ACTUA RAPIDO!", 105, row, { align: "center" });
      doc.setFont("Times", "normal");

      window.open(doc.output("bloburl"));
    }
  };

  const aceptarEvolucion = (e) => {
    if (selectedRow === null) {
      agregarEvolucion({
        paciente: selectedRowPaciente,
        evolucion: evolucion,
        usuario: state.usuario.usuario,
      });
      onHide();
      setTimeout(() => {
        obtenerEvoluciones({ pacienteId: selectedRowPaciente.id });
      }, 2000);
    }
  };

  const aceptarDiabetes = (e) => {
    if (
      diabete === undefined ||
      diabete === null ||
      diabete.fecha === undefined ||
      diabete.fecha === null ||
      diabete.fecha === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Diabetes",
        detail: "Debe indicar la fecha.",
        life: 3000,
      });
      return;
    }

    if (
      diabete === undefined ||
      diabete === null ||
      diabete.tipo === undefined ||
      diabete.tipo === null ||
      diabete.tipo === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Diabetes",
        detail: "Debe indicar el tipo.",
        life: 3000,
      });
      return;
    }

    if (
      diabete === undefined ||
      diabete === null ||
      diabete.medicacion === undefined ||
      diabete.medicacion === null ||
      diabete.medicacion === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Diabetes",
        detail: "Debe indicar la medicación.",
        life: 3000,
      });
      return;
    }

    if (
      diabete === undefined ||
      diabete === null ||
      diabete.valor === undefined ||
      diabete.valor === null ||
      diabete.valor === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Diabetes",
        detail: "Debe indicar el valor.",
        life: 3000,
      });
      return;
    }

    if (
      diabete === undefined ||
      diabete === null ||
      diabete.control === undefined ||
      diabete.control === null ||
      diabete.control === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Diabetes",
        detail: "Debe indicar el control.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarDiabetes({
        paciente: selectedRowPaciente,
        diabete,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarDiabetes({
        paciente: selectedRowPaciente,
        diabete,
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideDiabetes();
    setTimeout(() => {
      obtenerDiabetes({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };


  const aceptarAnticoagulados = (e) => {
    if (
      anticoagulado === undefined ||
      anticoagulado === null ||
      anticoagulado.fecha === undefined ||
      anticoagulado.fecha === null ||
      anticoagulado.fecha === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Anticoagulados",
        detail: "Debe indicar la fecha.",
        life: 3000,
      });
      return;
    }

    if (
      anticoagulado === undefined ||
      anticoagulado === null ||
      anticoagulado.tipo === undefined ||
      anticoagulado.tipo === null ||
      anticoagulado.tipo === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Anticoagulados",
        detail: "Debe indicar el tipo.",
        life: 3000,
      });
      return;
    }

    if (
      anticoagulado === undefined ||
      anticoagulado === null ||
      anticoagulado.medicacion === undefined ||
      anticoagulado.medicacion === null ||
      anticoagulado.medicacion === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Anticoagulados",
        detail: "Debe indicar la medicación.",
        life: 3000,
      });
      return;
    }

    if (
      anticoagulado === undefined ||
      anticoagulado === null ||
      anticoagulado.valor === undefined ||
      anticoagulado.valor === null ||
      anticoagulado.valor === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Anticoagulados",
        detail: "Debe indicar el valor.",
        life: 3000,
      });
      return;
    }

    if (
      anticoagulado === undefined ||
      anticoagulado === null ||
      anticoagulado.control === undefined ||
      anticoagulado.control === null ||
      anticoagulado.control === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Anticoagulados",
        detail: "Debe indicar el control.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarAnticoagulados({
        paciente: selectedRowPaciente,
        anticoagulado,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarAnticoagulados({
        paciente: selectedRowPaciente,
        anticoagulado,
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideAnticoagulados();
    setTimeout(() => {
      obtenerAnticoagulados({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };



  const aceptarFichasCaidas = (e) => {
    if (
      caida === undefined ||
      caida === null ||
      caida.fecha === undefined ||
      caida.fecha === null ||
      caida.fecha === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar la fecha.",
        life: 3000,
      });
      return;
    }

    if (
      caida === undefined ||
      caida === null ||
      caida.hora === undefined ||
      caida.hora === null ||
      caida.hora === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar la hora.",
        life: 3000,
      });
      return;
    }

    if (
      caida === undefined ||
      caida === null ||
      caida.lugar === undefined ||
      caida.lugar === null ||
      caida.lugar.trim() === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar el lugar.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarFichasCaidas({
        paciente: selectedRowPaciente,
        caida,
        primera,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarFichasCaidas({
        paciente: selectedRowPaciente,
        caida,
        primera,
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideFichasCaidas();
    setTimeout(() => {
      obtenerFichasCaidas({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };

  const aceptarUlceras = (e) => {
    if (
      ulcera === undefined ||
      ulcera === null ||
      ulcera.fecha === undefined ||
      ulcera.fecha === null ||
      ulcera.fecha === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar la fecha.",
        life: 3000,
      });
      return;
    }

    if (
      ulcera === undefined ||
      ulcera === null ||
      ulcera.valoracion === undefined ||
      ulcera.valoracion === null ||
      ulcera.valoracion === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar la valoración.",
        life: 3000,
      });
      return;
    }

    if (
      ulcera === undefined ||
      ulcera === null ||
      ulcera.localizacion === undefined ||
      ulcera.localizacion === null ||
      ulcera.localizacion.trim() === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar la localización.",
        life: 3000,
      });
      return;
    }

    if (
      ulcera === undefined ||
      ulcera === null ||
      ulcera.evolucion === undefined ||
      ulcera.evolucion === null ||
      ulcera.evolucion === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar la evolución.",
        life: 3000,
      });
      return;
    }

    if (
      ulcera === undefined ||
      ulcera === null ||
      ulcera.tto === undefined ||
      ulcera.tto === null ||
      ulcera.tto === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Fichas",
        detail: "Debe indicar el cambio de TTO.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarUlceras({
        paciente: selectedRowPaciente,
        ulcera,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarUlceras({
        paciente: selectedRowPaciente,
        ulcera,
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideUlceras();
    setTimeout(() => {
      obtenerUlceras({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };

  const aceptarEnfermeria = (e) => {
    if (
      enfermeria === undefined ||
      enfermeria === null ||
      enfermeria.fecha === undefined ||
      enfermeria.fecha === null ||
      enfermeria.fecha === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Enfermería",
        detail: "Debe indicar la fecha.",
        life: 3000,
      });
      return;
    }

    if (
      enfermeria === undefined ||
      enfermeria === null ||
      enfermeria.medicacion === undefined ||
      enfermeria.medicacion === null ||
      enfermeria.medicacion === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Enfermería",
        detail: "Debe indicar la medicación.",
        life: 3000,
      });
      return;
    }

    if (
      enfermeria === undefined ||
      enfermeria === null ||
      enfermeria.temperatura === undefined ||
      enfermeria.temperatura === null ||
      enfermeria.temperatura.trim() === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Enfermería",
        detail: "Debe indicar la temperatura.",
        life: 3000,
      });
      return;
    }

    if (
      enfermeria === undefined ||
      enfermeria === null ||
      enfermeria.tension === undefined ||
      enfermeria.tension === null ||
      enfermeria.tension === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Enfermería",
        detail: "Debe indicar la T.A.",
        life: 3000,
      });
      return;
    }

    if (
      enfermeria === undefined ||
      enfermeria === null ||
      enfermeria.frecuencia === undefined ||
      enfermeria.frecuencia === null ||
      enfermeria.frecuencia === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Enfermería",
        detail: "Debe indicar la F.C.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarEnfermerias({
        paciente: selectedRowPaciente,
        enfermeria,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarEnfermerias({
        paciente: selectedRowPaciente,
        enfermeria,
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideEnfermeria();
    setTimeout(() => {
      obtenerEnfermerias({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };

  const aceptarControlCaidas = (e) => {
    if (
      caida === undefined ||
      caida === null ||
      caida.fecha === undefined ||
      caida.fecha === null ||
      caida.fecha === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Control",
        detail: "Debe indicar la fecha.",
        life: 3000,
      });
      return;
    }

    if (
      caida === undefined ||
      caida === null ||
      caida.lugar === undefined ||
      caida.lugar === null ||
      caida.lugar.trim() === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Control",
        detail: "Debe indicar el lugar.",
        life: 3000,
      });
      return;
    }

    if (
      caida === undefined ||
      caida === null ||
      caida.consecuencias === undefined ||
      caida.consecuencias === null ||
      caida.consecuencias.trim() === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Control",
        detail: "Debe indicar las consecuencias.",
        life: 3000,
      });
      return;
    }

    if (
      caida === undefined ||
      caida === null ||
      caida.tratamiento === undefined ||
      caida.tratamiento === null ||
      caida.tratamiento.trim() === ""
    ) {
      toast.current.show({
        severity: "error",
        summary: "Control",
        detail: "Debe indicar el tratamiento.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarControlCaidas({
        paciente: selectedRowPaciente,
        caida,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarControlCaidas({
        paciente: selectedRowPaciente,
        caida,
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideControlCaidas();
    setTimeout(() => {
      obtenerControlCaidas({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };

  const onHide = (e) => {
    setDialogEvolucion(false);
    //setDialogCaidas(false);
  };

  const onHideEvoluciones = (e) => {
    setDialogEvoluciones(false);
    //setDialogCaidas(false);
  };

  const onHideFichasCaidas = (e) => {
    setDialogFichaCaida(false);
    //setDialogCaidas(false);
  };

  const onHideControlCaidas = (e) => {
    setDialogControlCaida(false);
    //setDialogCaidas(false);
  };

  const onHideDiabetes = (e) => {
    setDialogDiabetes(false);
    //setDialogCaidas(false);
  };

  const onHideAnticoagulados = (e) => {
    setDialogAnticoagulados(false);
    //setDialogCaidas(false);
  };

  const onHideUlceras = (e) => {
    setDialogUlcera(false);
    //setDialogCaidas(false);
  };

  const onHideEnfermeria = (e) => {
    setDialogEnfermeria(false);
    //setDialogCaidas(false);
  };

  const addClick = (e) => {
    setDialogPacientes(true);
    setSelectedRowPaciente(null);
  };

  const addClickEvolucion = (e) => {
    guardarEvolucion([]);
    setDialogEvolucion(true);
    setSelectedRow(null);
  };

  const addClickDiabetes = (e) => {
    guardarDiabete({});
    setDialogDiabetes(true);
    setSelectedRow(null);
  };

  const addClickAnticoagulados = (e) => {
    guardarAnticoagulado({});
    setDialogAnticoagulados(true);
    setSelectedRow(null);
  };

  const verClickEvolucion = (e) => {
    if (selectedRow) {
      guardarEvolucion(selectedRow.evolucion);
      setDialogEvolucion(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar una evolución.",
        life: 3000,
      });
    }
  };

  const verClickDiabetes = (e) => {
    if (selectedRow) {
      guardarDiabete(selectedRow);
      setDialogDiabetes(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un control.",
        life: 3000,
      });
    }
  };

  const verClickAnticoagulados = (e) => {
    if (selectedRow) {
      guardarAnticoagulado(selectedRow);
      setDialogAnticoagulados(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un control.",
        life: 3000,
      });
    }
  };

  const getEdad = (fecha) => {
    if (!fecha) {
      return null;
    }
    var year = Number(fecha.substr(0, 4));
    var month = Number(fecha.substr(5, 2)) - 1;
    var day = Number(fecha.substr(8, 2));

    var hoy = new Date();
    var edad = hoy.getFullYear() - year;
    if (
      hoy.getMonth() < month ||
      (hoy.getMonth() === month && hoy.getDate() < day)
    ) {
      edad--;
    }
    return edad;
  };

  const onHideSujecion = (e) => {
    setDialogSujecion(false);
  };

  const addClickSujecion = (e) => {
    const edad = selectedRowPaciente
      ? getEdad(selectedRowPaciente.fechaNacimiento)
      : null;
    guardarSujecion({
      nombreCompleto: selectedRowPaciente ? selectedRowPaciente.nombre : "",
      dniEdad:
        selectedRowPaciente && selectedRowPaciente.numeroDocumento
          ? `${selectedRowPaciente.numeroDocumento}${
              edad !== null ? " / " + edad + " años" : ""
            }`
          : "",
    });
    setDialogSujecion(true);
    setSelectedRow(null);
  };

  const verClickSujecion = (e) => {
    if (selectedRow) {
      guardarSujecion(selectedRow);
      setDialogSujecion(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar una orden.",
        life: 3000,
      });
    }
  };

  const aceptarSujecion = (e) => {
    if (!sujecion || !sujecion.tipoSujecion) {
      toast.current.show({
        severity: "error",
        summary: "Orden de Sujeción Mecánica",
        detail: "Debe indicar el tipo de sujeción indicada.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarOrdenSujecion({
        paciente: selectedRowPaciente,
        sujecion,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarOrdenSujecion({
        sujecion: { ...sujecion, id: selectedRow.id },
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideSujecion();
    setTimeout(() => {
      obtenerOrdenesSujecion({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };

  const onHideConfundido = (e) => {
    setDialogConfundido(false);
  };

  const addClickConfundido = (e) => {
    guardarConfundido({});
    setDialogConfundido(true);
    setSelectedRow(null);
  };

  const verClickConfundido = (e) => {
    if (selectedRow) {
      guardarConfundido(selectedRow);
      setDialogConfundido(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un registro.",
        life: 3000,
      });
    }
  };

  const aceptarConfundido = (e) => {
    if (selectedRow === null) {
      agregarResidenteConfundido({
        paciente: selectedRowPaciente,
        confundido,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarResidenteConfundido({
        confundido: { ...confundido, id: selectedRow.id },
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideConfundido();
    setTimeout(() => {
      obtenerResidentesConfundidos({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };

  const onHideFuga = (e) => {
    setDialogFuga(false);
  };

  const addClickFuga = (e) => {
    guardarFuga({});
    setDialogFuga(true);
    setSelectedRow(null);
  };

  const verClickFuga = (e) => {
    if (selectedRow) {
      guardarFuga(selectedRow);
      setDialogFuga(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un registro.",
        life: 3000,
      });
    }
  };

  const aceptarFuga = (e) => {
    if (!fuga || !fuga.horaFuga) {
      toast.current.show({
        severity: "error",
        summary: "Fuga",
        detail: "Debe indicar la hora de la fuga.",
        life: 3000,
      });
      return;
    }

    if (selectedRow === null) {
      agregarFuga({
        paciente: selectedRowPaciente,
        fuga,
        usuario: state.usuario.usuario,
      });
    } else {
      actualizarFuga({
        fuga: { ...fuga, id: selectedRow.id },
        usuario: state.usuario.usuario,
      });
    }
    setSelectedRow(null);
    onHideFuga();
    setTimeout(() => {
      obtenerFugas({ pacienteId: selectedRowPaciente.id });
    }, 2000);
  };

  const addClickFichasCaidas = (e) => {
    guardarCaida({});
    setPrimera("Si");
    setSelectedRow(null);
    setDialogFichaCaida(true);
  };

  const verClickFichasCaidas = (e) => {
    if (selectedRow) {
      guardarCaida({
        ...selectedRow,
        // la base devuelve fecha con hora; el input date necesita AAAA-MM-DD
        fecha: selectedRow.fecha ? String(selectedRow.fecha).slice(0, 10) : "",
        hora: selectedRow.hora ? String(selectedRow.hora).slice(0, 5) : "",
      });
      setPrimera(Number(selectedRow.primeraVez) === 1 ? "Si" : "No");
      setDialogFichaCaida(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar una ficha.",
        life: 3000,
      });
    }
  };

  const addClickUlceras = (e) => {
    guardarUlcera({});
    setSelectedRow(null);
    setDialogUlcera(true);
  };

  const addClickEnfermeria = (e) => {
    guardarEnfermeria({});
    setSelectedRow(null);
    setDialogEnfermeria(true);
  };

  const verClickUlceras = (e) => {
    if (selectedRow) {
      guardarUlcera(selectedRow);
      setDialogUlcera(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un control.",
        life: 3000,
      });
    }
  };

  const verClickEnfermeria = (e) => {
    if (selectedRow) {
      guardarEnfermeria(selectedRow);
      setDialogEnfermeria(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un control.",
        life: 3000,
      });
    }
  };

  const renderHeader = () => {
    return (
      <Fragment>
        <div>
          {selectedRowPaciente ? (
            <Tag value={"Residente " + selectedRowPaciente.nombre}></Tag>
          ) : null}
        </div>
        <div style={{ textAlign: "center" }}>
          {selectedRowPaciente ? (
            <Tag
              value={
                tipo === "evolucion"
                  ? "EVOLUCIONES"
                  : tipo === "caidas"
                  ? "CAIDAS"
                  : tipo === "diabetes"
                  ? "DIABETES"
                  : tipo === "ulceras"
                  ? "ULCERAS POR PRESION"
                  : tipo === "enfermeria"
                  ? "ENFERMERIA"
                  : tipo === "anticoagulados"
                  ? "ANTICOAGULADOS"
                  : tipo === "sujecion"
                  ? "ORDEN DE SUJECION MECANICA"
                  : tipo === "confundido"
                  ? "RESIDENTE CONFUNDIDO - PROTOCOLO DE DELIRIUM"
                  : tipo === "fuga"
                  ? "FUGA - PROTOCOLO DE ACCION"
                  : null
              }
            ></Tag>
          ) : null}
        </div>
      </Fragment>
    );
  };

  function formatDateTime(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate + " " + newTime;
  }

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const headerEvoluciones = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickEvolucion}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickEvolucion}
      />
    </Fragment>
  );

  const headerDiabetes = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickDiabetes}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickDiabetes}
      />
    </Fragment>
  );

  const headerAnticoagulados = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickAnticoagulados}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickAnticoagulados}
      />
    </Fragment>
  );

  const headerSujecion = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickSujecion}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickSujecion}
      />
    </Fragment>
  );

  const headerConfundido = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickConfundido}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickConfundido}
      />
    </Fragment>
  );

  const headerFuga = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickFuga}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickFuga}
      />
    </Fragment>
  );


  const headerFichaCaidas = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickFichasCaidas}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickFichasCaidas}
      />
    </Fragment>
  );

  const headerUlceras = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickUlceras}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickUlceras}
      />
    </Fragment>
  );

  const headerEnfermeria = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Agregar"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickEnfermeria}
      />
      <Button
        icon="pi pi-pencil"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClickEnfermeria}
      />
    </Fragment>
  );

  const renderHeaderEvoluciones = () => {
    return (
      <Fragment>
        <div>
          {selectedRowPaciente ? (
            <Tag value={"Residentes " + selectedRowPaciente.nombre}></Tag>
          ) : null}
        </div>

        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
          >
            <FormControlLabel
              value="caidas"
              control={<Radio />}
              label="Caídas"
            />
            <FormControlLabel
              value="diabetes"
              control={<Radio />}
              label="Diabetes"
            />
            <FormControlLabel
              value="ulceras"
              control={<Radio />}
              label="Ulceras por Presión"
            />
            <FormControlLabel
              value="enfermeria"
              control={<Radio />}
              label="Enfermería"
            />
            <FormControlLabel
              value="anticoagulados"
              control={<Radio />}
              label="Anticoagulados"
            />
            <FormControlLabel
              value="sujecion"
              control={<Radio />}
              label="Orden de Sujeción Mecánica"
            />
            <FormControlLabel
              value="confundido"
              control={<Radio />}
              label="Residente Confundido"
            />
            <FormControlLabel
              value="fuga"
              control={<Radio />}
              label="Fuga"
            />
          </RadioGroup>
        </FormControl>
      </Fragment>
    );
  };

  const headerPacientes = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            fullWidth
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Residentes"></Tag>
      </div>
    </Fragment>
  );

  const renderFooterPacientes = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClickPacientes}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHidePacientes}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const renderFooterEvolucion = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarEvolucion}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        {selectedRow !== null ? (
          <ButtonMui
            onClick={imprimir}
            color="error"
            type="button"
            fullWidth
            variant="contained"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Imprimir
          </ButtonMui>
        ) : null}
      </div>
    );
  };

  const renderFooterCaidas = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarFichasCaidas}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideFichasCaidas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        {selectedRow !== null ? (
          <ButtonMui
            onClick={imprimir}
            color="error"
            type="button"
            fullWidth
            variant="contained"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Imprimir
          </ButtonMui>
        ) : null}
      </div>
    );
  };

  const renderFooterControlCaidas = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarControlCaidas}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideControlCaidas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        {selectedRow !== null ? (
          <ButtonMui
            onClick={imprimir}
            color="error"
            type="button"
            fullWidth
            variant="contained"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Imprimir
          </ButtonMui>
        ) : null}
      </div>
    );
  };

  const renderFooterUlceras = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarUlceras}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideUlceras}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        {selectedRow !== null ? (
          <ButtonMui
            onClick={imprimir}
            color="error"
            type="button"
            fullWidth
            variant="contained"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Imprimir
          </ButtonMui>
        ) : null}
      </div>
    );
  };

  const renderFooterEnfermeria = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarEnfermeria}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideEnfermeria}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        {selectedRow !== null ? (
          <ButtonMui
            onClick={imprimir}
            color="error"
            type="button"
            fullWidth
            variant="contained"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Imprimir
          </ButtonMui>
        ) : null}
      </div>
    );
  };

  const renderFooterDiabetes = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarDiabetes}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideDiabetes}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        {selectedRow !== null ? (
          <ButtonMui
            onClick={imprimir}
            color="error"
            type="button"
            fullWidth
            variant="contained"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Imprimir
          </ButtonMui>
        ) : null}
      </div>
    );
  };

  const renderFooterAnticoagulados = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarAnticoagulados}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideAnticoagulados}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        {selectedRow !== null ? (
          <ButtonMui
            onClick={imprimir}
            color="error"
            type="button"
            fullWidth
            variant="contained"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Imprimir
          </ButtonMui>
        ) : null}
      </div>
    );
  };

  const renderFooterSujecion = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarSujecion}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideSujecion}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        <ButtonMui
          onClick={imprimir}
          color="error"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Imprimir
        </ButtonMui>
      </div>
    );
  };

  const renderFooterConfundido = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarConfundido}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideConfundido}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        <ButtonMui
          onClick={imprimir}
          color="error"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Imprimir
        </ButtonMui>
      </div>
    );
  };

  const renderFooterFuga = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarFuga}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHideFuga}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
        <ButtonMui
          onClick={imprimir}
          color="error"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Imprimir
        </ButtonMui>
      </div>
    );
  };


  const onHidePacientes = (e) => {
    setSelectedRowPaciente(null);
    setDialogPacientes(false);
  };

  const aceptarClickPacientes = (e) => {
    if (selectedRowPaciente) {
      //verificarHistoriaClinica({ selectedRowPaciente });
      //obtenerInformeFragilidad({ pacienteId: selectedRowPaciente.id });
      //obtenerInformesHistoriaClinica({ pacienteId: selectedRowPaciente.id });
      obtenerEvoluciones({ pacienteId: selectedRowPaciente.id });
      obtenerDiabetes({ pacienteId: selectedRowPaciente.id });
      obtenerAnticoagulados({ pacienteId: selectedRowPaciente.id });
      obtenerOrdenesSujecion({ pacienteId: selectedRowPaciente.id });
      obtenerResidentesConfundidos({ pacienteId: selectedRowPaciente.id });
      obtenerFugas({ pacienteId: selectedRowPaciente.id });
      setDialogPacientes(false);
      setTipo("caidas");
      setDialogEvoluciones(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un residente.",
        life: 3000,
      });
    }
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const fechaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Fecha</span>
        {formatDateTime(rowData.fecha)}
      </Fragment>
    );
  };

  const fecha2Template = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Fecha</span>
        {formatDate(rowData.fecha)}
      </Fragment>
    );
  };

  const nombreTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Nombre</span>
        {rowData.nombre}
      </Fragment>
    );
  };

  const documentoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Documento</span>
        {rowData.numeroDocumento}
      </Fragment>
    );
  };

  const domicilioTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Domicilio</span>
        {rowData.domicilio}
      </Fragment>
    );
  };

  const ingresoEgresoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Ingreso/Egreso</span>
        {formatDate(rowData.fechaIngresoEgreso)}
      </Fragment>
    );
  };

  const motivoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Motivo</span>
        {rowData.motivoIngresoEgreso}
      </Fragment>
    );
  };

  const activoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Activo</span>
        <Checkbox checked={rowData.activo}></Checkbox>
      </Fragment>
    );
  };

  const horaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Hora</span>
        {rowData.hora}
      </Fragment>
    );
  };

  const testigoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Testigo</span>
        {rowData.testigo}
      </Fragment>
    );
  };

  const lugarTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Lugar</span>
        {rowData.lugar}
      </Fragment>
    );
  };

  const consecuenciasTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Consecuencias</span>
        {rowData.consecuencias}
      </Fragment>
    );
  };

  const tratamientoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Tratamiento</span>
        {rowData.tratamiento}
      </Fragment>
    );
  };

  const valoracionTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Valoración</span>
        {rowData.valoracion}
      </Fragment>
    );
  };

  const localizacionTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Localización</span>
        {rowData.localizacion}
      </Fragment>
    );
  };

  const mejoraTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Mejora</span>
        <Checkbox checked={rowData.mejora}></Checkbox>
      </Fragment>
    );
  };

  const estableTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Estable</span>
        <Checkbox checked={rowData.estable}></Checkbox>
      </Fragment>
    );
  };

  const empeoraTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Empeora</span>
        <Checkbox checked={rowData.empeora}></Checkbox>
      </Fragment>
    );
  };

  const curadaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Curada</span>
        <Checkbox checked={rowData.curada}></Checkbox>
      </Fragment>
    );
  };

  const ttoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Cambio TTO</span>
        {rowData.tto}
      </Fragment>
    );
  };

  const medicacionTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Medicación</span>
        {rowData.medicacion}
      </Fragment>
    );
  };

  const temperaturaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Temperatura</span>
        {rowData.temperatura}
      </Fragment>
    );
  };

  const tensionTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">T.A.</span>
        {rowData.tension}
      </Fragment>
    );
  };

  const frecuenciaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">F.C.</span>
        {rowData.frecuencia}
      </Fragment>
    );
  };

  const observacionesTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Observaciones</span>
        {rowData.observaciones}
      </Fragment>
    );
  };

  function formatDate(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    return newDate;
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  //console.log(ulcera);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {evoluciones ? (
            <Fragment>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                  align: "center",
                  margin: "1em",
                  marginTop:
                    isMobile && !isPortrait
                      ? "22vw"
                      : isMobile && isPortrait
                      ? "55vw"
                      : "0vw",
                }}
              >
                <Button
                  icon="pi pi-search"
                  tooltip="Pacientes"
                  className="p-button-rounded p-button-help"
                  style={{ marginLeft: "0em" }}
                  onClick={addClick}
                />
                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />
              </Grid>

              <Dialog
                showHeader={false}
                visible={dialogPacientes}
                closable={false}
                footer={renderFooterPacientes()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "75vw", paddingBottom: "0" }}
                position="top"
              >
                <Grid container spacing={3} style={{ marginTop: "0vw" }}>
                  <Grid item xs={12} md={12}>
                    <div className="datatable-responsive-demo">
                      <div className="card">
                        <Tooltip
                          target=".export-buttons>button"
                          position="bottom"
                        />
                        <DataTable
                          value={pacientes}
                          selection={selectedRowPaciente}
                          onSelectionChange={(e) =>
                            setSelectedRowPaciente(e.value)
                          }
                          selectionMode="single"
                          dataKey="id"
                          header={headerPacientes}
                          className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                          style={{ fontSize: "small", marginTop: "1vw" }}
                          globalFilter={globalFilter}
                          emptyMessage="No hay datos."
                          paginator
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                          rows={10}
                          rowsPerPageOptions={[10, 20, 50]}
                          responsiveLayout="scroll"

                          //paginatorLeft={paginatorLeft}
                          //paginatorRight={paginatorRight}
                        >
                          <Column
                            field="id"
                            header="ID"
                            body={idTemplate}
                            sortable
                          ></Column>
                          <Column
                            field="nombre"
                            header="Apellido y Nombre"
                            body={nombreTemplate}
                            style={{ width: "30%" }}
                            sortable
                          ></Column>
                          <Column
                            field="domicilio"
                            header="Domicilio"
                            body={domicilioTemplate}
                            style={{ width: "30%" }}
                            sortable
                          ></Column>
                          <Column
                            field="numeroDocumento"
                            header="Documento"
                            body={documentoTemplate}
                            sortable
                          ></Column>
                          <Column
                            field="fechaIngresoEgreso"
                            header="Ingreso/Egreso"
                            body={ingresoEgresoTemplate}
                            sortable
                          ></Column>
                          <Column
                            field="motivoIngresoEgreso"
                            header="Motivo"
                            body={motivoTemplate}
                            sortable
                          ></Column>
                          <Column
                            field="activo"
                            header="Activo"
                            body={activoTemplate}
                            sortable
                          ></Column>
                        </DataTable>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeaderEvoluciones()}
                visible={dialogEvoluciones}
                maximized={true}
                //maximizable={true}
                closable={true}
                onHide={onHideEvoluciones}
                //footer={renderFooterEvoluciones()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "95vw", paddingBottom: "0" }}
                position="top"
              >
                <Grid container spacing={3} style={{ marginTop: "0vw" }}>
                  <Grid item xs={12} md={12}>
                    {tipo === "evolucion" && evoluciones ? (
                      <div className="datatable-responsive-demo">
                        <div className="card">
                          <Tooltip
                            target=".export-buttons>button"
                            position="bottom"
                          />
                          <DataTable
                            value={evoluciones}
                            selection={selectedRow}
                            onSelectionChange={(e) => setSelectedRow(e.value)}
                            selectionMode="single"
                            dataKey="id"
                            header={headerEvoluciones}
                            className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                            style={{ fontSize: "small", marginTop: "0vw" }}
                            //globalFilter={globalFilter}
                            emptyMessage="No hay datos."
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            responsiveLayout="scroll"

                            //paginatorLeft={paginatorLeft}
                            //paginatorRight={paginatorRight}
                          >
                            <Column
                              field="id"
                              header="ID"
                              body={idTemplate}
                              style={{ display: "none" }}
                              sortable
                            ></Column>
                            <Column
                              field="fecha"
                              header="Fecha"
                              body={fechaTemplate}
                              sortable
                              style={{ width: "10%" }}
                            ></Column>
                            <Column
                              field="evolucion"
                              header="Evolucion"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                          </DataTable>
                        </div>
                      </div>
                    ) : null}

                    {tipo === "caidas" && caidas ? (
                      <Grid item xs={12} md={12}>
                        <div className="card">
                          <TabView
                            activeIndex={activeIndex}
                            onTabChange={(e) => {
                              if (e.index === 1) {
                                obtenerFichasCaidas({
                                  pacienteId: selectedRowPaciente.id,
                                });
                              }
                              if (e.index === 2) {
                                obtenerControlCaidas({
                                  pacienteId: selectedRowPaciente.id,
                                });
                              }
                              setActiveIndex(e.index);
                            }}
                          >
                            <TabPanel header="Protocolo y Ficha">
                              <div>
                                <Document
                                  file={pdfCaidas}
                                  onLoadSuccess={onDocumentLoadSuccess}
                                >
                                  <Page pageNumber={pageNumber} />
                                </Document>
                                <p>
                                  <Button
                                    icon="pi pi-angle-left"
                                    className="p-button-rounded p-button-secondary"
                                    disabled={pageNumber <= 1}
                                    onClick={() =>
                                      setPageNumber((prev) => prev - 1)
                                    }
                                  />
                                  {" "}Page {pageNumber} of {numPages}{" "}
                                  <Button
                                    icon="pi pi-angle-right"
                                    className="p-button-rounded p-button-secondary"
                                    disabled={pageNumber >= numPages}
                                    onClick={() =>
                                      setPageNumber((prev) => prev + 1)
                                    }
                                  />
                                </p>
                              </div>

                              <ButtonMui
                                onClick={imprimir}
                                color="error"
                                type="button"
                                fullWidth
                                variant="contained"
                                startIcon={<CloseIcon />}
                                autoFocus
                              >
                                Imprimir
                              </ButtonMui>
                            </TabPanel>
                            <TabPanel header="Fichas de Caídas">
                              <div className="datatable-responsive-demo">
                                <div className="card">
                                  <DataTable
                                    value={caidas}
                                    selection={selectedRow}
                                    onSelectionChange={(e) =>
                                      setSelectedRow(e.value)
                                    }
                                    selectionMode="single"
                                    dataKey="id"
                                    header={headerFichaCaidas}
                                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                                    style={{
                                      fontSize: "small",
                                      marginTop: "0vw",
                                    }}
                                    emptyMessage="No hay datos."
                                    paginator
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                    rows={10}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    responsiveLayout="scroll"
                                  >
                                    <Column
                                      field="id"
                                      header="ID"
                                      style={{ display: "none" }}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="fecha"
                                      header="Fecha"
                                      body={(rowData) =>
                                        rowData.fecha
                                          ? formatDate(String(rowData.fecha))
                                          : ""
                                      }
                                      sortable
                                      style={{ width: "12%" }}
                                    ></Column>
                                    <Column
                                      field="hora"
                                      header="Hora"
                                      body={(rowData) =>
                                        rowData.hora
                                          ? String(rowData.hora).slice(0, 5)
                                          : ""
                                      }
                                      sortable
                                    ></Column>
                                    <Column
                                      field="lugar"
                                      header="Lugar"
                                      sortable
                                    ></Column>
                                    <Column
                                      field="lugar2"
                                      header="Lugar en la institución"
                                      sortable
                                    ></Column>
                                    <Column
                                      field="consecuencias"
                                      header="Consecuencias"
                                      sortable
                                    ></Column>
                                  </DataTable>
                                </div>
                              </div>
                            </TabPanel>
                          </TabView>
                        </div>
                      </Grid>
                    ) : null}

                    {tipo === "diabetes" && diabetes ? (
                      <div className="datatable-responsive-demo">
                        <div className="card">
                          <Tooltip
                            target=".export-buttons>button"
                            position="bottom"
                          />
                          <DataTable
                            value={diabetes}
                            selection={selectedRow}
                            onSelectionChange={(e) => setSelectedRow(e.value)}
                            selectionMode="single"
                            dataKey="id"
                            header={headerDiabetes}
                            className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                            style={{ fontSize: "small", marginTop: "0vw" }}
                            //globalFilter={globalFilter}
                            emptyMessage="No hay datos."
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            responsiveLayout="scroll"

                            //paginatorLeft={paginatorLeft}
                            //paginatorRight={paginatorRight}
                          >
                            <Column
                              field="id"
                              header="ID"
                              //body={idTemplate}
                              style={{ display: "none" }}
                              sortable
                            ></Column>
                            <Column
                              field="fecha"
                              header="Fecha"
                              //body={fechaTemplate}
                              sortable
                              style={{ width: "10%" }}
                            ></Column>
                            <Column
                              field="tipo"
                              header="Tipo"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                            <Column
                              field="medicacion"
                              header="Medicación"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                            <Column
                              field="valor"
                              header="Valor"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                            <Column
                              field="control"
                              header="Control"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                          </DataTable>
                        </div>
                      </div>
                    ) : null}

                    {tipo === "anticoagulados" && anticoagulados ? (
                      <div className="datatable-responsive-demo">
                        <div className="card">
                          <Tooltip
                            target=".export-buttons>button"
                            position="bottom"
                          />
                          <DataTable
                            value={anticoagulados}
                            selection={selectedRow}
                            onSelectionChange={(e) => setSelectedRow(e.value)}
                            selectionMode="single"
                            dataKey="id"
                            header={headerAnticoagulados}
                            className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                            style={{ fontSize: "small", marginTop: "0vw" }}
                            //globalFilter={globalFilter}
                            emptyMessage="No hay datos."
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            responsiveLayout="scroll"

                            //paginatorLeft={paginatorLeft}
                            //paginatorRight={paginatorRight}
                          >
                            <Column
                              field="id"
                              header="ID"
                              //body={idTemplate}
                              style={{ display: "none" }}
                              sortable
                            ></Column>
                            <Column
                              field="fecha"
                              header="Fecha"
                              //body={fechaTemplate}
                              sortable
                              style={{ width: "10%" }}
                            ></Column>
                            <Column
                              field="tipo"
                              header="Tipo"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                            <Column
                              field="medicacion"
                              header="Medicación"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                            <Column
                              field="valor"
                              header="Valor"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                            <Column
                              field="control"
                              header="Control"
                              //body={documentoTemplate}
                              sortable
                            ></Column>
                          </DataTable>
                        </div>
                      </div>
                    ) : null}

                    {tipo === "sujecion" && sujeciones ? (
                      <div className="datatable-responsive-demo">
                        <div className="card">
                          <Tooltip
                            target=".export-buttons>button"
                            position="bottom"
                          />
                          <DataTable
                            value={sujeciones}
                            selection={selectedRow}
                            onSelectionChange={(e) => setSelectedRow(e.value)}
                            selectionMode="single"
                            dataKey="id"
                            header={headerSujecion}
                            className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                            style={{ fontSize: "small", marginTop: "0vw" }}
                            emptyMessage="No hay datos."
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            responsiveLayout="scroll"
                          >
                            <Column
                              field="id"
                              header="ID"
                              style={{ display: "none" }}
                              sortable
                            ></Column>
                            <Column
                              field="fecha"
                              header="Fecha"
                              body={fecha2Template}
                              sortable
                              style={{ width: "12%" }}
                            ></Column>
                            <Column
                              field="tipoSujecion"
                              header="Tipo de Sujeción"
                              sortable
                            ></Column>
                            <Column
                              field="usuario"
                              header="Usuario"
                              sortable
                            ></Column>
                          </DataTable>
                        </div>
                      </div>
                    ) : null}

                    {tipo === "confundido" && confundidos ? (
                      <div className="datatable-responsive-demo">
                        <div className="card">
                          <Tooltip
                            target=".export-buttons>button"
                            position="bottom"
                          />
                          <DataTable
                            value={confundidos}
                            selection={selectedRow}
                            onSelectionChange={(e) => setSelectedRow(e.value)}
                            selectionMode="single"
                            dataKey="id"
                            header={headerConfundido}
                            className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                            style={{ fontSize: "small", marginTop: "0vw" }}
                            emptyMessage="No hay datos."
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            responsiveLayout="scroll"
                          >
                            <Column
                              field="id"
                              header="ID"
                              style={{ display: "none" }}
                              sortable
                            ></Column>
                            <Column
                              field="fecha"
                              header="Fecha"
                              body={fecha2Template}
                              sortable
                              style={{ width: "12%" }}
                            ></Column>
                            <Column
                              field="usuario"
                              header="Usuario"
                              sortable
                            ></Column>
                          </DataTable>
                        </div>
                      </div>
                    ) : null}

                    {tipo === "fuga" && fugas ? (
                      <div className="datatable-responsive-demo">
                        <div className="card">
                          <Tooltip
                            target=".export-buttons>button"
                            position="bottom"
                          />
                          <DataTable
                            value={fugas}
                            selection={selectedRow}
                            onSelectionChange={(e) => setSelectedRow(e.value)}
                            selectionMode="single"
                            dataKey="id"
                            header={headerFuga}
                            className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                            style={{ fontSize: "small", marginTop: "0vw" }}
                            emptyMessage="No hay datos."
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            responsiveLayout="scroll"
                          >
                            <Column
                              field="id"
                              header="ID"
                              style={{ display: "none" }}
                              sortable
                            ></Column>
                            <Column
                              field="fecha"
                              header="Fecha"
                              body={fecha2Template}
                              sortable
                              style={{ width: "12%" }}
                            ></Column>
                            <Column
                              field="horaFuga"
                              header="Hora Fuga"
                              sortable
                            ></Column>
                            <Column
                              field="encontrado"
                              header="Encontrado"
                              body={(rowData) => (rowData.encontrado ? "SI" : "NO")}
                              sortable
                            ></Column>
                            <Column
                              field="usuario"
                              header="Usuario"
                              sortable
                            ></Column>
                          </DataTable>
                        </div>
                      </div>
                    ) : null}

                    {tipo === "ulceras" && ulceras ? (
                      <Grid item xs={12} md={12}>
                        <div className="card">
                          <TabView
                            activeIndex={activeIndex}
                            onTabChange={(e) => {
                              if (e.index === 1) {
                                obtenerUlceras({
                                  pacienteId: selectedRowPaciente.id,
                                });
                              }
                              setActiveIndex(e.index);
                            }}
                          >
                            <TabPanel header="Protocolo">
                              <div>
                                <Document
                                  file={pdfUlceras}
                                  onLoadSuccess={onDocumentLoadSuccess}
                                >
                                  <Page pageNumber={pageNumber} />
                                </Document>
                                <p>
                                  Page {pageNumber} of {numPages}
                                </p>
                                <button
                                  onClick={() => {
                                    if (pageNumber !== 1) {
                                      setPageNumber(pageNumber - 1);
                                    }
                                  }}
                                >
                                  Página anterior
                                </button>
                                <button
                                  onClick={() => {
                                    if (pageNumber !== 4) {
                                      setPageNumber(pageNumber + 1);
                                    }
                                  }}
                                >
                                  Página siguiente
                                </button>
                              </div>
                              <ButtonMui
                                onClick={imprimir}
                                color="error"
                                type="button"
                                fullWidth
                                variant="contained"
                                startIcon={<CloseIcon />}
                                autoFocus
                              >
                                Imprimir
                              </ButtonMui>
                            </TabPanel>
                            <TabPanel header="Controles">
                              <div className="datatable-responsive-demo">
                                <div className="card">
                                  <Tooltip
                                    target=".export-buttons>button"
                                    position="bottom"
                                  />
                                  <DataTable
                                    value={ulceras}
                                    selection={selectedRow}
                                    onSelectionChange={(e) =>
                                      setSelectedRow(e.value)
                                    }
                                    selectionMode="single"
                                    dataKey="id"
                                    header={headerUlceras}
                                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                                    style={{
                                      fontSize: "small",
                                      marginTop: "0vw",
                                    }}
                                    //globalFilter={globalFilter}
                                    emptyMessage="No hay datos."
                                    paginator
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                    rows={10}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    responsiveLayout="scroll"

                                    //paginatorLeft={paginatorLeft}
                                    //paginatorRight={paginatorRight}
                                  >
                                    <Column
                                      field="id"
                                      header="ID"
                                      body={idTemplate}
                                      style={{ display: "none" }}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="fecha"
                                      header="Fecha"
                                      body={fecha2Template}
                                      sortable
                                      style={{ width: "10%" }}
                                    ></Column>
                                    <Column
                                      field="valoracion"
                                      header="Valoración"
                                      body={valoracionTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="localizacion"
                                      header="Localizacion"
                                      body={localizacionTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="mejora"
                                      header="Mejora"
                                      body={mejoraTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="estable"
                                      header="Estable"
                                      body={estableTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="empeora"
                                      header="Empeora"
                                      body={empeoraTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="curada"
                                      header="Curada"
                                      body={curadaTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="tto"
                                      header="Cambio TTO"
                                      body={ttoTemplate}
                                      sortable
                                    ></Column>
                                  </DataTable>
                                </div>
                              </div>
                            </TabPanel>
                          </TabView>
                        </div>
                      </Grid>
                    ) : null}

                    {tipo === "enfermeria" && enfermerias ? (
                      <Grid item xs={12} md={12}>
                        <div className="card">
                          <TabView
                            activeIndex={activeIndex}
                            onTabChange={(e) => {
                              if (e.index === 1) {
                                obtenerEnfermerias({
                                  pacienteId: selectedRowPaciente.id,
                                });
                              }
                              setActiveIndex(e.index);
                            }}
                          >
                            {/*
                            <TabPanel header="Protocolo">
                              <div>
                                <Document
                                  file={pdfEnfermeria}
                                  onLoadSuccess={onDocumentLoadSuccess}
                                >
                                  <Page pageNumber={pageNumber} />
                                </Document>
                                <p>
                                  Page {pageNumber} of {numPages}
                                </p>
                                <button
                                  onClick={() => {
                                    if (pageNumber !== 1) {
                                      setPageNumber(pageNumber - 1);
                                    }
                                  }}
                                >
                                  Página anterior
                                </button>
                                <button
                                  onClick={() => {
                                    if (pageNumber !== 2) {
                                      setPageNumber(pageNumber + 1);
                                    }
                                  }}
                                >
                                  Página siguiente
                                </button>
                              </div>
                              <ButtonMui
                                onClick={imprimir}
                                color="error"
                                type="button"
                                fullWidth
                                variant="contained"
                                startIcon={<CloseIcon />}
                                autoFocus
                              >
                                Imprimir
                              </ButtonMui>
                            </TabPanel>
                                */}
                            <TabPanel header="Controles">
                              <div className="datatable-responsive-demo">
                                <div className="card">
                                  <Tooltip
                                    target=".export-buttons>button"
                                    position="bottom"
                                  />
                                  <DataTable
                                    value={enfermerias}
                                    selection={selectedRow}
                                    onSelectionChange={(e) =>
                                      setSelectedRow(e.value)
                                    }
                                    selectionMode="single"
                                    dataKey="id"
                                    header={headerEnfermeria}
                                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                                    style={{
                                      fontSize: "small",
                                      marginTop: "0vw",
                                    }}
                                    //globalFilter={globalFilter}
                                    emptyMessage="No hay datos."
                                    paginator
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                                    rows={10}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    responsiveLayout="scroll"

                                    //paginatorLeft={paginatorLeft}
                                    //paginatorRight={paginatorRight}
                                  >
                                    <Column
                                      field="id"
                                      header="ID"
                                      body={idTemplate}
                                      style={{ display: "none" }}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="fecha"
                                      header="Fecha"
                                      body={fecha2Template}
                                      sortable
                                      style={{ width: "10%" }}
                                    ></Column>
                                    <Column
                                      field="medicacion"
                                      header="Medicación"
                                      body={medicacionTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="temperatura"
                                      header="Temperatura"
                                      body={temperaturaTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="tension"
                                      header="T.A."
                                      body={tensionTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="frecuencia"
                                      header="F.C."
                                      body={frecuenciaTemplate}
                                      sortable
                                    ></Column>
                                    <Column
                                      field="observaciones"
                                      header="Observaciones"
                                      body={observacionesTemplate}
                                      sortable
                                    ></Column>
                                  </DataTable>
                                </div>
                              </div>
                            </TabPanel>
                          </TabView>
                        </div>
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogEvolucion}
                closable={true}
                footer={renderFooterEvolucion()}
                maximizable={true}
                onHide={onHide}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "90vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={12} md={12}>
                    <textarea
                      rows="20"
                      //cols="100"
                      name="text"
                      placeholder="Ingrese evolución"
                      disabled={selectedRow !== null}
                      value={evolucion}
                      onChange={(e) => guardarEvolucion(e.target.value)}
                      style={{ width: "100%" }}
                    ></textarea>
                  </Grid>
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogFichaCaida}
                closable={true}
                footer={renderFooterCaidas()}
                maximizable={true}
                onHide={onHideFichasCaidas}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "90vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={6} md={2}>
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="date"
                      fullWidth
                      variant="standard"
                      value={caida && caida.fecha ? caida.fecha : null}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          fecha: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      id="hora"
                      label="Hora"
                      type="time"
                      fullWidth
                      variant="standard"
                      value={caida && caida.hora ? caida.hora : null}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          hora: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={8}>
                    <TextField
                      id="testigo"
                      inputProps={{ maxLength: 100 }}
                      label="Testigo"
                      fullWidth
                      variant="standard"
                      value={caida && caida.testigo ? caida.testigo : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          testigo: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  {[
                    ["lugar", "Lugar del acontecimiento", opcionesLugar],
                    ["lugar2", "Lugar de la institución", opcionesLugarInstitucion],
                  ].map(([campo, etiqueta, lista]) => {
                    const { opcion, otro } = separarOpcion(
                      caida && caida[campo],
                      lista
                    );
                    return (
                      <Grid item xs={12} md={12} key={campo}>
                        <FormControl>
                          <RadioGroup
                            row
                            value={opcion}
                            onChange={(e) =>
                              guardarCaida({
                                ...caida,
                                [campo]: unirOpcion(e.target.value, otro),
                              })
                            }
                          >
                            <FormLabel
                              style={{
                                fontWeight: "bold",
                                marginRight: "1vw",
                                marginTop: ".5vw",
                              }}
                            >
                              {etiqueta}:
                            </FormLabel>
                            {lista.map((o) => (
                              <FormControlLabel
                                key={o}
                                value={o}
                                control={<Radio />}
                                label={o}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                        {opcion === "Otro" ? (
                          <TextField
                            label="Especificar otro"
                            variant="standard"
                            inputProps={{ maxLength: 90 }}
                            value={otro}
                            onChange={(e) =>
                              guardarCaida({
                                ...caida,
                                [campo]: unirOpcion("Otro", e.target.value),
                              })
                            }
                          />
                        ) : null}
                      </Grid>
                    );
                  })}

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="circunstancia"
                      inputProps={{ maxLength: 255 }}
                      label="Circunstancia"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.circunstancia
                          ? caida.circunstancia
                          : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          circunstancia: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="diagnostico"
                      inputProps={{ maxLength: 255 }}
                      label="Diagnóstico"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.diagnostico ? caida.diagnostico : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          diagnostico: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="intercurrencias"
                      inputProps={{ maxLength: 255 }}
                      label="Intercurrencias médicas que puedan influir"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.intercurrencias
                          ? caida.intercurrencias
                          : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          intercurrencias: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="medicamentos"
                      inputProps={{ maxLength: 255 }}
                      label="Medicamentos que ingiere"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.medicamentos ? caida.medicamentos : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          medicamentos: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="piso"
                      inputProps={{ maxLength: 45 }}
                      label="Piso"
                      fullWidth
                      variant="standard"
                      value={caida && caida.piso ? caida.piso : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          piso: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="iluminacion"
                      inputProps={{ maxLength: 45 }}
                      label="Iluminación"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.iluminacion ? caida.iluminacion : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          iluminacion: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="obstaculos"
                      inputProps={{ maxLength: 45 }}
                      label="Obstaculos"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.obstaculos ? caida.obstaculos : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          obstaculos: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="barandas"
                      inputProps={{ maxLength: 45 }}
                      label="Barandas"
                      fullWidth
                      variant="standard"
                      value={caida && caida.barandas ? caida.barandas : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          barandas: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="cama"
                      inputProps={{ maxLength: 45 }}
                      label="Cama"
                      fullWidth
                      variant="standard"
                      value={caida && caida.cama ? caida.cama : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          cama: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="escaleras"
                      inputProps={{ maxLength: 45 }}
                      label="Escaleras"
                      fullWidth
                      variant="standard"
                      value={caida && caida.escaleras ? caida.escaleras : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          escaleras: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="calzado"
                      inputProps={{ maxLength: 45 }}
                      label="Calzado"
                      fullWidth
                      variant="standard"
                      value={caida && caida.calzado ? caida.calzado : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          calzado: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="silla"
                      inputProps={{ maxLength: 45 }}
                      label="Silla"
                      fullWidth
                      variant="standard"
                      value={caida && caida.silla ? caida.silla : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          silla: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="acompanante"
                      inputProps={{ maxLength: 45 }}
                      label="Acompañante"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.acompanante ? caida.acompanante : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          acompanante: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={3} style={{ marginTop: "1.5vw" }}>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      Primera Vez
                      <SelectButton
                        value={primera}
                        options={veces}
                        onChange={(e) => setPrimera(e.value)}
                        style={{
                          float: "right",
                          marginTop: "-0.5vw",
                        }}
                      />
                    </FormLabel>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="tinetti"
                      label="Escala de Tinetti"
                      fullWidth
                      variant="standard"
                      value={caida && caida.tinetti ? caida.tinetti : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          tinetti: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="consecuencias"
                      label="Consecuencias"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.consecuencias
                          ? caida.consecuencias
                          : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          consecuencias: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  {campoResumen(caida && caida.resumen, (valor) =>
                    guardarCaida({ ...caida, resumen: valor })
                  )}
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogControlCaida}
                closable={true}
                footer={renderFooterControlCaidas()}
                maximizable={true}
                onHide={onHideControlCaidas}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "90vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={6} md={2}>
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="date"
                      fullWidth
                      variant="standard"
                      value={caida && caida.fecha ? caida.fecha : null}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          fecha: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="lugar"
                      label="Lugar del acontecimiento: (institución) (calle) casa) (otro)"
                      fullWidth
                      variant="standard"
                      value={caida && caida.lugar ? caida.lugar : null}
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          lugar: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="consecuencias"
                      label="Consecuencias"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.consecuencias
                          ? caida.consecuencias
                          : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          consecuencias: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="tratamiento"
                      label="Tratamiento"
                      fullWidth
                      variant="standard"
                      value={
                        caida && caida.tratamiento ? caida.tratamiento : null
                      }
                      onChange={(e) =>
                        guardarCaida({
                          ...caida,
                          tratamiento: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogDiabetes}
                closable={true}
                footer={renderFooterDiabetes()}
                maximizable={true}
                onHide={onHideDiabetes}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "75vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={6} md={2}>
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="date"
                      fullWidth
                      variant="standard"
                      value={diabete && diabete.fecha ? diabete.fecha : null}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarDiabete({
                          ...diabete,
                          fecha: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="tipo"
                      label="Tipo"
                      fullWidth
                      variant="standard"
                      value={diabete && diabete.tipo ? diabete.tipo : null}
                      onChange={(e) =>
                        guardarDiabete({
                          ...diabete,
                          tipo: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="medicacion"
                      label="Medicación"
                      fullWidth
                      variant="standard"
                      value={
                        diabete && diabete.medicacion
                          ? diabete.medicacion
                          : null
                      }
                      onChange={(e) =>
                        guardarDiabete({
                          ...diabete,
                          medicacion: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="valor"
                      label="Valor"
                      fullWidth
                      variant="standard"
                      value={diabete && diabete.valor ? diabete.valor : null}
                      onChange={(e) =>
                        guardarDiabete({
                          ...diabete,
                          valor: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="control"
                      label="Control"
                      fullWidth
                      variant="standard"
                      value={
                        diabete && diabete.control ? diabete.control : null
                      }
                      onChange={(e) =>
                        guardarDiabete({
                          ...diabete,
                          control: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  {campoResumen(diabete && diabete.resumen, (valor) =>
                    guardarDiabete({ ...diabete, resumen: valor })
                  )}
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogAnticoagulados}
                closable={true}
                footer={renderFooterAnticoagulados()}
                maximizable={true}
                onHide={onHideAnticoagulados}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "75vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={6} md={2}>
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="date"
                      fullWidth
                      variant="standard"
                      value={anticoagulado && anticoagulado.fecha ? anticoagulado.fecha : null}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarAnticoagulado({
                          ...anticoagulado,
                          fecha: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="tipo"
                      label="Tipo"
                      fullWidth
                      variant="standard"
                      value={anticoagulado && anticoagulado.tipo ? anticoagulado.tipo : null}
                      onChange={(e) =>
                        guardarAnticoagulado({
                          ...anticoagulado,
                          tipo: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="medicacion"
                      label="Medicación"
                      fullWidth
                      variant="standard"
                      value={
                        anticoagulado && anticoagulado.medicacion
                          ? anticoagulado.medicacion
                          : null
                      }
                      onChange={(e) =>
                        guardarAnticoagulado({
                          ...anticoagulado,
                          medicacion: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="valor"
                      label="Valor"
                      fullWidth
                      variant="standard"
                      value={anticoagulado && anticoagulado.valor ? anticoagulado.valor : null}
                      onChange={(e) =>
                        guardarAnticoagulado({
                          ...anticoagulado,
                          valor: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="control"
                      label="Control"
                      fullWidth
                      variant="standard"
                      value={
                        anticoagulado && anticoagulado.control ? anticoagulado.control : null
                      }
                      onChange={(e) =>
                        guardarAnticoagulado({
                          ...anticoagulado,
                          control: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  {campoResumen(anticoagulado && anticoagulado.resumen, (valor) =>
                    guardarAnticoagulado({ ...anticoagulado, resumen: valor })
                  )}
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogSujecion}
                closable={true}
                footer={renderFooterSujecion()}
                maximizable={true}
                onHide={onHideSujecion}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "85vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={12} md={12}>
                    <Typography variant="h6" style={{ textDecoration: "underline" }}>
                      Datos del Residente
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="nombreCompleto"
                      label="Nombre Completo"
                      fullWidth
                      variant="standard"
                      value={sujecion && sujecion.nombreCompleto ? sujecion.nombreCompleto : ""}
                      onChange={(e) =>
                        guardarSujecion({ ...sujecion, nombreCompleto: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="dniEdad"
                      label="DNI / Edad"
                      fullWidth
                      variant="standard"
                      value={sujecion && sujecion.dniEdad ? sujecion.dniEdad : ""}
                      onChange={(e) =>
                        guardarSujecion({ ...sujecion, dniEdad: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="habitacionPiso"
                      label="Habitación / Piso"
                      fullWidth
                      variant="standard"
                      value={sujecion && sujecion.habitacionPiso ? sujecion.habitacionPiso : ""}
                      onChange={(e) =>
                        guardarSujecion({ ...sujecion, habitacionPiso: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="diagnosticoPrincipal"
                      label="Diagnóstico Principal"
                      fullWidth
                      variant="standard"
                      value={
                        sujecion && sujecion.diagnosticoPrincipal
                          ? sujecion.diagnosticoPrincipal
                          : ""
                      }
                      onChange={(e) =>
                        guardarSujecion({ ...sujecion, diagnosticoPrincipal: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="medicacionActual"
                      label="Medicación Actual"
                      fullWidth
                      variant="standard"
                      value={
                        sujecion && sujecion.medicacionActual ? sujecion.medicacionActual : ""
                      }
                      onChange={(e) =>
                        guardarSujecion({ ...sujecion, medicacionActual: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12} style={{ marginTop: "1vw" }}>
                    <Typography variant="h6" style={{ textDecoration: "underline" }}>
                      Motivo de la Sujeción Mecánica
                    </Typography>
                  </Grid>

                  {[
                    ["motivoLevantarse", "Intento REPETIDO de levantarse de cama (riesgo de caída/fractura)"],
                    ["motivoCateter", "Arrancarse catéter / sonda / venoclisis (riesgo de sangrado)"],
                    ["motivoAgitacion", "Agitación SEVERA con autolesiones (golpearse)"],
                    ["motivoAgresion", "Agresión directa a personal de residencia"],
                    ["motivoDeambulacion", "Deambulación peligrosa / inestabilidad severa"],
                    ["motivoOtro", "Otro"],
                  ].map(([campo, etiqueta]) => (
                    <Grid item xs={12} md={6} key={campo}>
                      <FormControl>
                        <RadioGroup
                          row
                          value={sujecion && sujecion[campo] !== undefined ? sujecion[campo] : null}
                          onChange={(e) =>
                            guardarSujecion({ ...sujecion, [campo]: e.target.value })
                          }
                        >
                          <FormLabel
                            style={{
                              fontWeight: "bold",
                              marginRight: "1vw",
                              marginTop: ".5vw",
                            }}
                          >
                            {etiqueta}
                          </FormLabel>
                          <FormControlLabel value={true} control={<Radio />} label="SI" />
                          <FormControlLabel value={false} control={<Radio />} label="NO" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  ))}

                  {sujecion && (sujecion.motivoOtro === true || sujecion.motivoOtro === "true") ? (
                    <Grid item xs={12} md={12}>
                      <TextField
                        id="motivoOtroTexto"
                        label="Especificar"
                        fullWidth
                        variant="standard"
                        value={sujecion.motivoOtroTexto || ""}
                        onChange={(e) =>
                          guardarSujecion({ ...sujecion, motivoOtroTexto: e.target.value })
                        }
                      />
                    </Grid>
                  ) : null}

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="descripcionRiesgo"
                      label="Descripción detallada del riesgo y conducta"
                      fullWidth
                      multiline
                      minRows={3}
                      variant="standard"
                      value={sujecion && sujecion.descripcionRiesgo ? sujecion.descripcionRiesgo : ""}
                      onChange={(e) =>
                        guardarSujecion({ ...sujecion, descripcionRiesgo: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12} style={{ marginTop: "1vw" }}>
                    <Typography variant="h6" style={{ textDecoration: "underline" }}>
                      Alternativas Intentadas antes de la Sujeción
                    </Typography>
                  </Grid>

                  {[
                    ["altNoFarmacologica", "Intervención no-farmacológica (ambiente tranquilo, validación emocional)"],
                    ["altRedireccionamiento", "Redireccionamiento de atención (actividades, música, paseo)"],
                    ["altCausaMedica", "Evaluación de causa médica (fiebre, dolor, infección, medicación)"],
                    ["altMedicacion", "Medicación considerada (ansiolíticos si corresponde)"],
                    ["altPersonal", "Aumento de personal (vigilancia intensiva)"],
                  ].map(([campo, etiqueta]) => (
                    <Grid item xs={12} md={6} key={campo}>
                      <FormControl>
                        <RadioGroup
                          row
                          value={sujecion && sujecion[campo] !== undefined ? sujecion[campo] : null}
                          onChange={(e) =>
                            guardarSujecion({ ...sujecion, [campo]: e.target.value })
                          }
                        >
                          <FormLabel
                            style={{
                              fontWeight: "bold",
                              marginRight: "1vw",
                              marginTop: ".5vw",
                            }}
                          >
                            {etiqueta}
                          </FormLabel>
                          <FormControlLabel value={true} control={<Radio />} label="SI" />
                          <FormControlLabel value={false} control={<Radio />} label="NO" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  ))}

                  <Grid item xs={12} md={12} style={{ marginTop: "1vw" }}>
                    <Typography variant="h6" style={{ textDecoration: "underline" }}>
                      Tipo de Sujeción Indicada
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <FormControl>
                      <RadioGroup
                        row
                        value={sujecion && sujecion.tipoSujecion ? sujecion.tipoSujecion : null}
                        onChange={(e) =>
                          guardarSujecion({ ...sujecion, tipoSujecion: e.target.value })
                        }
                      >
                        <FormControlLabel
                          value="Cinturón de seguridad"
                          control={<Radio />}
                          label="Cinturón de seguridad (en cama o silla)"
                        />
                        <FormControlLabel
                          value="Pulseras suave"
                          control={<Radio />}
                          label="Pulseras suave (muñecas y/o tobillos)"
                        />
                        <FormControlLabel
                          value="Chaleco de contención"
                          control={<Radio />}
                          label="Chaleco de contención"
                        />
                        <FormControlLabel
                          value="Manta con sistema de fijación"
                          control={<Radio />}
                          label="Manta con sistema de fijación"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {campoResumen(sujecion && sujecion.resumen, (valor) =>
                    guardarSujecion({ ...sujecion, resumen: valor })
                  )}
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogConfundido}
                closable={true}
                footer={renderFooterConfundido()}
                maximizable={true}
                onHide={onHideConfundido}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "85vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={12} md={12}>
                    <Typography variant="h6" style={{ textDecoration: "underline" }}>
                      Reconocer los Signos (¿Tiene delirium?)
                    </Typography>
                  </Grid>

                  {[
                    ["signoCambioBrusco", "Cambio BRUSCO (de golpe, no gradual)"],
                    ["signoConfusionDesorientacion", "Confusión / Desorientación"],
                    ["signoFluctuacion", "Fluctuación (mejor mañana, peor noche)"],
                    ["signoDificultadConcentracion", "Dificultad concentración"],
                    ["signoCambiosEmocionales", "Cambios emocionales rápidos"],
                    ["signoAlucinaciones", "Alucinaciones / Ve cosas"],
                    ["signoSuenoInvertido", "Sueño invertido (duerme día, despierto noche)"],
                  ].map(([campo, etiqueta]) => (
                    <Grid item xs={12} md={6} key={campo}>
                      <FormControl>
                        <RadioGroup
                          row
                          value={
                            confundido && confundido[campo] !== undefined
                              ? confundido[campo]
                              : null
                          }
                          onChange={(e) =>
                            guardarConfundido({ ...confundido, [campo]: e.target.value })
                          }
                        >
                          <FormLabel
                            style={{
                              fontWeight: "bold",
                              marginRight: "1vw",
                              marginTop: ".5vw",
                            }}
                          >
                            {etiqueta}
                          </FormLabel>
                          <FormControlLabel value={true} control={<Radio />} label="SI" />
                          <FormControlLabel value={false} control={<Radio />} label="NO" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  ))}

                  <Grid item xs={12} md={12} style={{ marginTop: "1vw" }}>
                    <Typography variant="h6" style={{ textDecoration: "underline" }}>
                      Mientras Esperas Médico - Buscar Causa
                    </Typography>
                  </Grid>

                  {[
                    ["causaFiebre", "¿Tiene fiebre? (tocar frente)"],
                    ["causaITU", "¿Hay síntomas de ITU? (disuria, orina turbia)"],
                    ["causaTosDificultadRespirar", "¿Tiene tos, dificultad respirar? (neumonía)"],
                    ["causaMedicacionReciente", "¿Medicación reciente? (nueva droga)"],
                    ["causaCambioAmbiental", "¿Cambio ambiental? (ingreso, cambio cuarto)"],
                    ["causaRetencion", "¿Retención urinaria o fecal?"],
                    ["causaDolor", "¿Dolor? (expresión de dolor)"],
                  ].map(([campo, etiqueta]) => (
                    <Grid item xs={12} md={6} key={campo}>
                      <FormControl>
                        <RadioGroup
                          row
                          value={
                            confundido && confundido[campo] !== undefined
                              ? confundido[campo]
                              : null
                          }
                          onChange={(e) =>
                            guardarConfundido({ ...confundido, [campo]: e.target.value })
                          }
                        >
                          <FormLabel
                            style={{
                              fontWeight: "bold",
                              marginRight: "1vw",
                              marginTop: ".5vw",
                            }}
                          >
                            {etiqueta}
                          </FormLabel>
                          <FormControlLabel value={true} control={<Radio />} label="SI" />
                          <FormControlLabel value={false} control={<Radio />} label="NO" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  ))}
                  {campoResumen(confundido && confundido.resumen, (valor) =>
                    guardarConfundido({ ...confundido, resumen: valor })
                  )}
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogFuga}
                closable={true}
                footer={renderFooterFuga()}
                maximizable={true}
                onHide={onHideFuga}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "85vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={12} md={12}>
                    <Typography
                      variant="h6"
                      style={{ color: "red", fontWeight: "bold" }}
                    >
                      ¡LOS PRIMEROS 10 MINUTOS SON CRÍTICOS! — Policía: 101 /
                      Emergencia: 911
                    </Typography>
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      id="horaFuga"
                      label="Hora de la fuga"
                      type="time"
                      fullWidth
                      variant="standard"
                      value={fuga && fuga.horaFuga ? fuga.horaFuga : ""}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarFuga({ ...fuga, horaFuga: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextField
                      id="descripcionFisica"
                      label="Descripción física (altura, pelo, complexión)"
                      fullWidth
                      multiline
                      variant="standard"
                      value={
                        fuga && fuga.descripcionFisica ? fuga.descripcionFisica : ""
                      }
                      onChange={(e) =>
                        guardarFuga({ ...fuga, descripcionFisica: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextField
                      id="ropa"
                      label="Ropa que llevaba"
                      fullWidth
                      multiline
                      variant="standard"
                      value={fuga && fuga.ropa ? fuga.ropa : ""}
                      onChange={(e) =>
                        guardarFuga({ ...fuga, ropa: e.target.value })
                      }
                    />
                  </Grid>

                  {seccionesFuga.map(({ titulo, items }) => (
                    <Fragment key={titulo}>
                      <Grid item xs={12} md={12} style={{ marginTop: "1vw" }}>
                        <Typography
                          variant="h6"
                          style={{ textDecoration: "underline" }}
                        >
                          {titulo}
                        </Typography>
                      </Grid>

                      {items.map(([campo, etiqueta]) => (
                        <Grid item xs={12} md={6} key={campo}>
                          <FormControlLabel
                            control={
                              <CheckboxMui
                                checked={esSi(fuga && fuga[campo])}
                                onChange={(e) =>
                                  guardarFuga({ ...fuga, [campo]: e.target.checked })
                                }
                              />
                            }
                            label={etiqueta}
                          />
                        </Grid>
                      ))}
                    </Fragment>
                  ))}

                  <Grid item xs={12} md={12} style={{ marginTop: "1vw" }}>
                    <Typography variant="h6" style={{ textDecoration: "underline" }}>
                      Resultado
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl>
                      <RadioGroup
                        row
                        value={
                          fuga && fuga.encontrado !== undefined
                            ? fuga.encontrado
                            : null
                        }
                        onChange={(e) =>
                          guardarFuga({ ...fuga, encontrado: e.target.value })
                        }
                      >
                        <FormLabel
                          style={{
                            fontWeight: "bold",
                            marginRight: "1vw",
                            marginTop: ".5vw",
                          }}
                        >
                          ¿Fue encontrado?
                        </FormLabel>
                        <FormControlLabel value={true} control={<Radio />} label="SI" />
                        <FormControlLabel value={false} control={<Radio />} label="NO" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} md={2}>
                    <TextField
                      id="horaEncontrado"
                      label="Hora encontrado"
                      type="time"
                      fullWidth
                      variant="standard"
                      value={fuga && fuga.horaEncontrado ? fuga.horaEncontrado : ""}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarFuga({ ...fuga, horaEncontrado: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <TextField
                      id="lugarEncontrado"
                      label="Lugar donde fue encontrado"
                      fullWidth
                      variant="standard"
                      value={
                        fuga && fuga.lugarEncontrado ? fuga.lugarEncontrado : ""
                      }
                      onChange={(e) =>
                        guardarFuga({ ...fuga, lugarEncontrado: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <TextField
                      id="observaciones"
                      label="Observaciones"
                      fullWidth
                      multiline
                      rows={3}
                      variant="standard"
                      value={fuga && fuga.observaciones ? fuga.observaciones : ""}
                      onChange={(e) =>
                        guardarFuga({ ...fuga, observaciones: e.target.value })
                      }
                    />
                  </Grid>
                  {campoResumen(fuga && fuga.resumen, (valor) =>
                    guardarFuga({ ...fuga, resumen: valor })
                  )}
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogUlcera}
                closable={true}
                footer={renderFooterUlceras()}
                maximizable={true}
                onHide={onHideUlceras}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "75vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={6} md={2}>
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="date"
                      fullWidth
                      variant="standard"
                      value={ulcera && ulcera.fecha ? ulcera.fecha : null}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarUlcera({
                          ...ulcera,
                          fecha: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="valoracion"
                      label="Valoración del riesgo"
                      fullWidth
                      variant="standard"
                      value={
                        ulcera && ulcera.valoracion ? ulcera.valoracion : null
                      }
                      onChange={(e) =>
                        guardarUlcera({
                          ...ulcera,
                          valoracion: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="localizacion"
                      label="Localización"
                      fullWidth
                      variant="standard"
                      value={
                        ulcera && ulcera.localizacion
                          ? ulcera.localizacion
                          : null
                      }
                      onChange={(e) =>
                        guardarUlcera({
                          ...ulcera,
                          localizacion: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <FormControl>
                      <FormLabel
                        id="evolucion"
                        style={{ fontWeight: "bold", fontSize: "large" }}
                      >
                        Evolución de la ulcera
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="evolucion"
                        value={
                          ulcera && ulcera.evolucion ? ulcera.evolucion : null
                        }
                        onChange={(e) =>
                          guardarUlcera({
                            ...ulcera,
                            evolucion: e.target.value,
                          })
                        }
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Mejora."
                        />
                        <FormControlLabel
                          value="2"
                          control={<Radio />}
                          label="Estable."
                        />
                        <FormControlLabel
                          value="3"
                          control={<Radio />}
                          label="Empeora."
                        />
                        <FormControlLabel
                          value="4"
                          control={<Radio />}
                          label="Curada."
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      id="tto"
                      label="Cambio de TTO"
                      fullWidth
                      variant="standard"
                      value={ulcera && ulcera.tto ? ulcera.tto : null}
                      onChange={(e) =>
                        guardarUlcera({
                          ...ulcera,
                          tto: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  {campoResumen(ulcera && ulcera.resumen, (valor) =>
                    guardarUlcera({ ...ulcera, resumen: valor })
                  )}
                </Grid>
              </Dialog>

              <Dialog
                header={renderHeader()}
                visible={dialogEnfermeria}
                closable={true}
                footer={renderFooterEnfermeria()}
                maximizable={true}
                onHide={onHideEnfermeria}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "75vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid
                  container
                  spacing={3}
                  style={{ margin: "2vw", width: "auto" }}
                >
                  <Grid item xs={6} md={2}>
                    <TextField
                      id="fecha"
                      label="Fecha"
                      type="date"
                      fullWidth
                      variant="standard"
                      value={
                        enfermeria && enfermeria.fecha ? enfermeria.fecha : null
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        guardarEnfermeria({
                          ...enfermeria,
                          fecha: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={10}>
                    <TextField
                      id="medicacion"
                      label="Medicación"
                      fullWidth
                      variant="standard"
                      value={
                        enfermeria && enfermeria.medicacion
                          ? enfermeria.medicacion
                          : null
                      }
                      onChange={(e) =>
                        guardarEnfermeria({
                          ...enfermeria,
                          medicacion: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="temperatura"
                      label="Temperatura"
                      fullWidth
                      variant="standard"
                      value={
                        enfermeria && enfermeria.temperatura
                          ? enfermeria.temperatura
                          : null
                      }
                      onChange={(e) =>
                        guardarEnfermeria({
                          ...enfermeria,
                          temperatura: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="tension"
                      label="T.A."
                      fullWidth
                      variant="standard"
                      value={
                        enfermeria && enfermeria.tension
                          ? enfermeria.tension
                          : null
                      }
                      onChange={(e) =>
                        guardarEnfermeria({
                          ...enfermeria,
                          tension: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="frecuencia"
                      label="F.C."
                      fullWidth
                      variant="standard"
                      value={
                        enfermeria && enfermeria.frecuencia
                          ? enfermeria.frecuencia
                          : null
                      }
                      onChange={(e) =>
                        guardarEnfermeria({
                          ...enfermeria,
                          frecuencia: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      id="observaciones"
                      label="Observaciones"
                      fullWidth
                      variant="standard"
                      value={
                        enfermeria && enfermeria.observaciones
                          ? enfermeria.observaciones
                          : null
                      }
                      onChange={(e) =>
                        guardarEnfermeria({
                          ...enfermeria,
                          observaciones: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  {campoResumen(enfermeria && enfermeria.resumen, (valor) =>
                    guardarEnfermeria({ ...enfermeria, resumen: valor })
                  )}
                </Grid>
              </Dialog>
            </Fragment>
          ) : (
            <Spinner />
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Fragment>
      ) : null}
      {exit ? <Navigate to="/login" /> : null}
    </Fragment>
  );
}
